import common from './common'
import featuresPay from './feature'

const ms = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Produk/Varian",
        serialNumber: "Nombor Siri",
        noProductsFound: "Tiada produk dijumpai",
        searchByProductSku: "Cari mengikut produk/SKU",
        searchSerialNumbers: "Cari nombor siri",
        transactionDetails: "Butiran Transaksi",
        notAvailable: "N/A",
        mainWarehouse: "Gudang Utama"
    },
    new_build_banner: {
        title: 'Versi baru:',
        is_available: 'kini tersedia',
        fallback_title: 'Versi baru aplikasi tersedia',
        desc: 'Segarkan untuk mendapatkan ciri dan penambahbaikan terkini.',
        refreshing: 'Menyegarkan…',
        refresh_now: 'Segar Sekarang',
        later: 'Nanti',
        you_are_on: "anda sedang menggunakan"
    },
    short: {
        finance: 'Kewangan',
        stock: 'Stok'
    },
    onboarding: {
        welcome: 'Selamat Datang!',
        step: {
            product: {
                totalBreakdown: 'Pecahan Jumlah',
                overallFulfilment: 'Pemenuhan Keseluruhan',
                totalShippedQty: 'Jumlah Kuantiti Dihantar',
                totalReceivedQty: 'Jumlah Kuantiti Diterima',
                totalOrderedQty: 'Jumlah Kuantiti Dipesan',
                totalShippedOrdered: 'Jumlah Dihantar / Dipesan',
                totalReceivedOrdered: 'Jumlah Diterima / Dipesan',
                viewQty: 'Lihat Kuantiti',
                fetchingQty: 'Mengambil butiran kuantiti...',
                noStockInfo: 'Tiada maklumat stok ditemui',
                title: '65% Tercapai',
                description: 'Hanya 2 langkah lagi untuk memulakan kejayaan besar anda!',
                Warehouse: "Gudang",
            },
            stock: {
                title: '95% Hampir Selesai!!',
                description: 'Hanya satu langkah lagi untuk memulakan kejayaan besar anda! Selesaikan sekarang.'
            }
        },
        business: {
            title: 'Perniagaan berjaya dicipta!',
            description: 'Hebat! Perniagaan anda telah didaftarkan'
        },
        product: {
            title: 'Tambah produk pertama anda',
            description: 'Tambah produk untuk mula merekod stok',
            Warehouse: "Gudang",
        },
        stock: {
            title: 'Cuba tambah stok',
            description: 'Mula merekod stok masuk dan stok keluar'
        },
        action: {
            add_business: {
                title: 'Cipta Perniagaan',
                description: 'Ingin cipta perniagaan baru? Klik di sini'
            },
            join_business: {
                title: 'Sertai Perniagaan',
                description: 'Ada kod jemputan? Sertai di sini'
            }
        }
    },
    business: {
        title: 'Pilih perniagaan, cipta baru, atau sertai',
        add_business: {
            title: 'Cipta perniagaan baru',
            name: 'Nama Perniagaan',
            name_placeholder: 'Masukkan nama',
            category: 'Kategori Perniagaan',
            category_placeholder: 'Pilih Kategori',
            button: 'Cipta Perniagaan'
        },
        edit_business: {
            title: 'Sunting perniagaan'
        },
        join_business: {
            title: 'Sertai Perniagaan',
            input_code: 'Masukkan kod jemputan di bawah:',
            field_placeholder: 'Kod jemputan',
            confirm_title: 'Sertai',
            confirm_text: 'Anda akan menjadi sebahagian daripada pasukan di '
        },
        no_business: 'Tiada perniagaan tersedia',
        create_or_join: 'Cipta atau sertai perniagaan',
        message: {
            saved: 'Perniagaan berjaya disimpan!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Transaksi stok negatif',
            isNegativeTransactionDisabledHint: 'Dengan menghidupkan ini, anda dapat mencegah transaksi yang akan mengakibatkan stok negatif.',
            negativeStockError: 'Transaksi stok negatif dilumpuhkan'
        }
    },
    profile: {
        edit_profile: {
            title: 'Sunting profil',
            name: 'Nama Penuh',
            name_placeholder: 'Masukkan nama penuh',
            email: 'Emel',
            phone_number: 'Nombor Telefon'
        },
        message: {
            required_name: 'Nama diperlukan'
        }
    },
    product: {
        weightedAverageCost: 'Kos Purata Wajaran',
        weightedAverageValueLabel: 'Nilai Purata Wajaran',
        Product: 'Produk',
        hideZeroStock: 'Sembunyi Stok Sifar',
        allVariants: 'Semua Varian',
        choose_product: 'Pilih Produk',
        choose_product_empty: 'Pilih produk dan masukkan kuantiti',
        choose_product_empty_manufacturing: 'Pilih produk dan masukkan kuantiti pembuatan',
        search: {
            placeholder: 'Cari mengikut nama',
            tooltip: 'Buka pengimbas',
            Warehouse: "Gudang",
        },
        column: {
            image: 'Gambar',
            name: 'Nama',
            price: 'Harga',
            buying_price: 'Harga Kos',
            selling_price: 'Harga Jual',
            sku: 'SKU',
            stock: 'Stok',
            quantity: 'Kuantiti',
            latest_stock: 'Baki',
            product_deleted: 'Produk telah dipadam',
            info_not_found: 'Maklumat tidak tersedia',
            expired_date: 'Tarikh Luput',
            invoice: 'Invois'
        },
        no_product: 'Tiada Produk Tersedia',
        no_product_subtitle: 'Tambah produk pertama anda untuk mula menjejaki stok, harga dan jualan.',
        create_first_product: 'Cipta produk pertama anda',
        add_product: {
            sku: 'Kod Produk',
            sku_placeholder: 'Kod Produk. Contoh: 12345',
            name: 'Nama Produk',
            name_placeholder: 'Masukkan Nama Produk',
            initial_stock: 'Stok Awal',
            initial_stock_placeholder: 'Masukkan Stok Awal',
            buying_price: 'Harga Kos',
            buying_price_placeholder: 'Masukkan Harga Kos',
            selling_price: 'Harga Jual',
            selling_price_placeholder: 'Masukkan Harga Jual',
            category: 'Kategori',
            category_placeholder: 'Pilih Kategori',
            add_selling_price: 'Tambah Harga Borong',
            expired_date: 'Tarikh Luput',
            expired_date_placeholder: 'Pilih Tarikh',
            description: 'Penerangan',
            description_placeholder: 'Masukkan Penerangan',
            custom_label: 'Atribut',
            custom_label_placeholder: 'Masukkan Kunci',
            add_custom_label: 'Tambah Atribut Lagi',
            Warehouse: "Gudang",
        },
        customerLabel: {},
        choose_selling_price: 'Pilih Harga Jual',
        selling_price: 'Harga Jual',
        total_product: 'Jumlah Produk',
        total_quantity: 'Jumlah Stok',
        total_buying_price: 'Jumlah Harga Kos',
        total_selling_price: 'Jumlah Harga Jual',
        message: {
            required_name: 'Nama produk diperlukan',
            required_sku: 'SKU diperlukan',
            required_category: 'Kategori diperlukan',
            required_quantity: 'Stok awal diperlukan',
            invalid_input_qty: 'Kuantiti stok tidak sah',
            required_buying_price: 'Harga kos diperlukan',
            required_selling_price: 'Harga jual diperlukan',
            required_selling_price_name: 'Nama harga jual diperlukan',
            required_selling_price_price: 'Harga jual diperlukan'
        },
        viewMore: 'Lihat Lagi',
        WarehouseDetails: 'Butiran Gudang',
        WarehouseName: 'Nama Gudang',
        AddWarehouse: 'Tambah Gudang',
        WarehouseQty: 'Kuantiti Gudang',
        Warehouse: 'Gudang',
        Warehouses: 'Gudang-gudang',
        Variants: 'Varian',
        VariantName: 'Nama Varian',
        productVariant: 'Varian Produk',
        AddVariant: 'Tambah Varian',
        TranferItem: 'Pindah Barang',
        AddUnit: 'Unit Baru',
        InitialStkWarehouse: 'Stok Awal diperlukan untuk tambah varian',
        InitialStockinwarehouse: 'Stok Awal di gudang',
        TotalQuantity: 'Jumlah Kuantiti:',
        AddNote: 'Tambah Nota (Harga Kos)',
        AddNotetitle: 'Tambah Nota',
        VariantSuccessMessage: 'Varian produk berjaya dikemas kini',
        Next: 'Seterusnya',
        Submit: 'Hantar',
        INACTIVE: 'TIDAK AKTIF',
        errorone: 'Oops! Kuantiti yang diminta untuk',
        errortwo: "tidak sepadan dengan kuantiti gudang yang diperuntukkan. Sila laras kuantiti atau tambah stok semula.",
        SelectWarehouse: 'Pilih Gudang',
        SelectVariant: 'Pilih Varian',
        Discount: 'Diskaun',
        DiscountDetails: 'Butiran Diskaun',
        FinalPrice: 'Harga Akhir',
        DiscountType: 'Jenis Diskaun',
        DiscountPer: 'Diskaun %',
        DiscountValue: 'Nilai Diskaun',
        Discountonprice: 'Diskaun pada harga',
        Discountondiscount: 'Diskaun pada diskaun',
        AdditionalDiscount: 'Diskaun Tambahan',
        SellingPrice: 'Harga Jual:',
        Save: 'Simpan',
        OnOriginalPrice: 'Pada Harga Asal',
        OnDiscountedPrice: 'Pada Harga Selepas Diskaun',
        columnSelector: {
            title: 'Tunjukkan Lajur',
            columnsButton: 'Lajur',
            costPrice: 'Harga Kos',
            sellingPrice: 'Harga Jual',
            sku: 'SKU',
            warehouse: 'Gudang',
            categories: 'Kategori',
            safetyStock: 'Stok Keselamatan',
            attributes: 'Atribut',
            notes: 'Nota',
            description: 'Penerangan',
            more: 'lagi',
            attribute: 'Atribut',
            attributesTitle: 'Atribut',
            categoriesTitle: 'Kategori',
            skuAliases: 'Alias SKU'
        }
    },
    note: {
        title: 'Nota',
        add: 'Tambah Nota',
        no_note: 'Tiada nota tersedia'
    },
    settings: {
        category: 'Kategori',
        language: 'Bahasa',
        switch_business: 'Tukar Perniagaan',
        currencySelect: 'Mata Wang',
        languageChangeSuccess: 'Mata Wang Berjaya Dikemas Kini',
        languageChangeErrorMessage: 'Sesuatu telah berlaku semasa mengemas kini Mata Wang',
        currencyAdded: "Mata wang berjaya ditambah",
        currencyDelete: "Mata wang berjaya dipadam",
        Selectyourpreferredlanguage: "Pilih bahasa pilihan anda",
    },
    selectProductStock: 'Pilih Produk',
    category: {
        category_list: {
            title: 'Kategori Produk'
        },
        add_category: {
            button: 'Kategori Baru',
            title: 'Tambah Kategori Baru'
        },
        edit_category: {
            title: 'Sunting Kategori'
        },
        name: 'Nama Kategori',
        name_placeholder: 'Masukkan Nama Kategori',
        no_category: 'Tiada kategori tersedia'
    },
    staff: {
        add: 'Tambah Kakitangan',
        edit: 'Sunting Kakitangan',
        access: {
            stock: 'Stok',
            add_product: 'Tambah produk baru',
            edit_product: 'Sunting produk',
            delete_product: 'Padam produk',
            view_capital_price: 'Lihat Harga Kos',
            add_category: 'Tambah kategori baru',
            edit_category: 'Sunting kategori',
            delete_category: 'Padam kategori',
            add_supplier: 'Tambah pembekal baru',
            edit_supplier: 'Sunting pembekal',
            delete_supplier: 'Padam pembekal',
            add_customer: 'Tambah pelanggan baru',
            edit_customer: 'Sunting pelanggan',
            delete_customer: 'Padam pelanggan',
            add_staff: 'Tambah kakitangan',
            edit_staff: 'Sunting kakitangan',
            delete_staff: 'Padam kakitangan',
            change_business_profile: 'Ubah profil perniagaan',
            access_by_product_category: 'Akses mengikut Kategori Produk',
            no_category_message: 'Anda belum menambah sebarang kategori. Sila tambah senarai kategori terlebih dahulu.',
            expenses: 'Perbelanjaan',
            view_expenses: 'Lihat Perbelanjaan',
            add_expenses: 'Tambah Perbelanjaan',
            edit_expenses: 'Sunting Perbelanjaan',
            delete_expenses: 'Padam Perbelanjaan',
            warehouse: 'Gudang',
            add_new_warehouse: 'Tambah Gudang Baru',
            edit_warehouse: 'Sunting Gudang',
            delete_warehouse: 'Padam Gudang',
            transfer_warehouse: 'Pindah Gudang',
            transfer_warehouse_approval: 'Kelulusan Pindah Gudang',
            can_do_available_warehouse: 'Boleh melakukan gudang tersedia',
            access_by_warehouse: 'Akses melalui Gudang',
            no_warehouse_message: 'Anda belum menambah sebarang gudang. Sila tambah senarai gudang terlebih dahulu.',
            purchase_order: "Pesanan pembelian",
            purchase_order_creation: "Penciptaan pesanan pembelian",
            purchase_order_edit: "Edit pesanan pembelian",
            purchase_order_cancel: "Batalkan pesanan pembelian",
            purchase_order_reopen: "Buka semula pesanan pembelian",
            purchase_order_receive: "Penerimaan pesanan pembelian",
            sales_order: "Pesanan jualan",
            sales_order_creation: "Penciptaan pesanan jualan",
            sales_order_edit: "Edit pesanan jualan",
            sales_order_cancel: "Batalkan pesanan jualan",
            sales_order_reopen: "Buka semula pesanan jualan",
            sales_order_receive: "Pesanan jualan dihantar",
            purchase_order_approval: "Kelulusan pesanan pembelian",
            sales_order_approval: "Kelulusan pesanan jualan",
            add_batch: "Kelulusan penciptaan batch"
            ,
            notification: 'Notification',
            staffNotification: 'Enable Notification',
            assignee: "Pemegang Tugas",
        },
        no_staff: 'Tiada kakitangan tersedia.'
    },
    code: {
        title: 'Kakitangan Baru Berjaya Ditambah!',
        subtitle: 'Kongsi kod jemputan di bawah untuk menyertai:',
        valid: 'Kod sah selama 48 jam sahaja',
        share: 'Kongsi di WhatsApp',
        copied: 'Disalin!',
        invalid: 'Kod tidak sah!'
    },
    history: {
        no_history: 'Tiada sejarah.',
        detail: {
            remove: 'Padam Sejarah',
            confirm: 'Ciri ini akan memberi kesan kepada stok sedia ada, sejarah, dan laporan.'
        },
        no_history_selected: "Tiada sejarah dipilih",
        select_history_hint: "Klik sejarah daripada senarai untuk melihat butirannya",
        select_from_left: "Pilih dari panel kiri",
    },
    supplier: {
        add: {
            title: 'Tambah Pembekal'
        },
        edit: {
            title: 'Sunting Pembekal'
        },
        new: 'Pembekal baru',
        no_supplier: 'Tiada pembekal tersedia.',
        bank: {
            title: 'Butiran Bank'
        },
        note: 'Nota',
        form: {
            name: {
                label: 'Nama Pembekal',
                placeholder: 'Masukkan Nama Pembekal',
                placheolder_not_mandatory: 'Masukkan nama',
                error: {
                    required: 'Nama tidak boleh kosong'
                }
            },
            contact: {
                label: 'Nombor Telefon',
                placeholder: '601934554432',
                error: {
                    required: 'Nombor telefon tidak boleh kosong',
                    invalid: 'Nombor tidak sah. Mesti termasuk kod negara'
                }
            },
            bank_name: {
                label: 'Nama Bank',
                placeholder: 'Masukkan Nama Bank'
            },
            bank_account_name: {
                label: 'Nama Pemegang Akaun',
                placeholder: 'Masukkan Nama Pemegang Akaun'
            },
            bank_account_number: {
                label: 'Nombor Akaun',
                placeholder: 'Masukkan Nombor Akaun'
            },
            note: {
                label: 'Nota',
                placeholder: 'Tambah Nota'
            },
            openingBalance: {
                addBtn: 'Tambah Baki Pembukaan',
                label: 'Baki Pembukaan',
                placeholder: 'Masukkan Baki Pembukaan',
                error: {
                    negative: 'Baki pembukaan tidak boleh bernilai negatif'
                }
            }
        },
        choose: 'Pilih Pembekal'
    },
    customer: {
        add: {
            title: 'Tambah Pelanggan'
        },
        edit: {
            title: 'Sunting Pelanggan'
        },
        new: 'Pelanggan baru',
        no_customer: 'Tiada pelanggan tersedia.',
        note: 'Nota',
        form: {
            name: {
                label: 'Nama Pelanggan',
                placeholder: 'Masukkan Nama Pelanggan',
                placheolder_not_mandatory: 'Masukkan nama',
                error: {
                    required: 'Nama tidak boleh kosong'
                }
            },
            contact: {
                label: 'Nombor Telefon',
                placeholder: '601934554432',
                error: {
                    required: 'Nombor telefon tidak boleh kosong',
                    invalid: 'Nombor tidak sah. Mesti termasuk kod negara'
                }
            },
            address: {
                label: 'Alamat',
                placeholder: 'Masukkan Alamat'
            },
            note: {
                label: 'Nota',
                placeholder: 'Tambah Nota'
            },
            openingBalance: {
                addBtn: 'Tambah Baki Pembukaan',
                label: 'Baki Pembukaan',
                placeholder: 'Masukkan Baki Pembukaan',
                error: {
                    negative: 'Baki pembukaan tidak boleh bernilai negatif'
                }
            }
        },
        choose: "Pilih Pelanggan",
        report: {
            view: 'Lihat Laporan Pelanggan',
            title: 'Laporan Pelanggan',
            no_report: 'Tiada laporan untuk pelanggan pada tarikh yang dipilih.',
            column: {
                name: 'Nama',
                total_transaction: 'Jumlah Transaksi',
                total_amount: 'Jumlah Jualan',
                total_profit: 'Jumlah Keuntungan'
            }
        }
    },
    confirm_delete: 'Adakah anda pasti mahu memadam data ini?',
    report: {
        title: 'Laporan'
    },
    accounting: {
        download_pdf_report: 'Muat turun PDF',
        title: 'Perakaunan',
        view_report: 'Lihat Laporan Kewangan',
        dashboard_title: 'Laporan Kewangan',
        stats: 'Statistik',
        accounting_report: 'Laporan Perakaunan',
        filter: {
            date: {
                placeholder: 'Pilih Tarikh',
                submit: 'Guna',
                cancel: 'Set Semula Penapis'
            },
            timeframe: {
                day: 'Harian',
                week: 'Mingguan',
                month: 'Bulanan',
                year: 'Tahunan'
            }
        },
        total_sales: 'Jumlah Jualan',
        total_purchases: 'Jumlah Pembelian',
        total_profit: 'Jumlah Keuntungan',
        total_expenses: 'Jumlah Perbelanjaan',
        assets_value: 'Nilai Aset Semasa',
        total_current_cogs_value: 'Jumlah Nilai Semasa COGS',
        current_asset_selling_price: 'Harga Jualan Aset Semasa',
        total_selling_price: 'Jumlah Harga Jualan',
        table: {
            date: 'Tarikh',
            sales: 'Jualan',
            purchases: 'Pembelian',
            profit: 'Keuntungan',
            expenses: 'Perbelanjaan'
        },
        no_data: 'Tiada data tersedia.'
    },
    stock_report: {
        title: 'Laporan Stok',
        view: 'Lihat Laporan Stok',
        no_report: 'Tiada rekod stok untuk tarikh atau kakitangan yang dipilih.',
        allStaffPlaceHolder: 'Semua Kakitangan',
        column: {
            total_product: 'Jenis Produk Semasa',
            total_product_quantity: 'Jumlah Produk Semasa'
        }
    },
    subscription: {
        paywall_small: {
            title: 'Ciri VIP',
            description:
                'Tempoh percubaan untuk ciri ini telah tamat. Sokong pembangunan aplikasi tempatan ini dengan melanggan.',
            button: 'Lihat Pelan Langganan'
        }
    },
    payment: {
        order: {
            title: 'Pembayaran'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Saiz imej tidak boleh melebihi 5MB!',
        failedMessage: 'Gagal memuat naik imej barang, sila cuba lagi!',
        successUpload: 'Imej berjaya dimuat naik!',
        failedUIError: 'Gagal memadam imej, sila cuba lagi!',
        SuccessErrorImage: 'Imej berjaya dipadam!'
    },
    productColumns: {
        SKULabel: 'SKU',
        nameLabel: 'Nama Produk',
        categoryLabel: 'Kategori',
        BuyingPriceLabel: 'Harga Beli',
        SellingLabel: 'Harga Jual',
        StockLabel: 'Stok'
    },
    historyColumns: {
        Transactionlabel: 'Jenis Transaksi',
        Locallabel: 'Masa Tempatan',
        Createdlabel: 'Dicipta Oleh',
        Vendorlabel: 'Nama Pembekal',
        Buyerlabel: 'Nama Pembeli',
        SKUlabel: 'SKU',
        Invoicelabel: 'Invois',
        Productlabel: 'Nama Produk',
        Categorylabel: 'Kategori',
        Buyinglabel: 'Harga Beli',
        Sellinglabel: 'Harga Jual',
        Initiallabel: 'Stok Awal',
        Finallabel: 'Stok Akhir',
        Stocklabel: 'Perubahan Stok'
    },
    stockReportColumns: {
        skuLabel: 'SKU',
        productNameLabel: 'Nama Produk',
        categoryLabel: 'Kategori',
        buyingPriceLabel: 'Harga Beli',
        sellingPriceLabel: 'Harga Jual',
        stockInLabel: 'Stok Masuk',
        stockOutLabel: 'Stok Keluar',
        remainingStockLabel: 'Baki Stok',
        openStockLabel: 'Stok Awal',
        weightedAverageCost: 'Kos Purata Wajaran',
        weightedAverageCostLabel: 'Kos Purata Wajaran',
        weightedAverageValueLabel: 'Nilai Purata Wajaran'
    },
    accountingReportColumns: {
        dateRange: 'Julat tarikh',
        reportingPeriod: 'Tempoh Laporan',
        reportGenerate: 'Laporan Dijana',
        warehouse: 'Gudang',
        labelDate: 'Tarikh',
        labelSales: 'Jualan',
        labelPurchases: 'Pembelian',
        labelProfit: 'Keuntungan',
        labelExpenses: 'Perbelanjaan',
        reportOptions: 'Lajur Laporan',
        summaryCards: 'Kad Ringkasan',
        grandTotal: 'Jumlah Keseluruhan',
        continued: 'sambungan',
        subtotal: 'Subjumlah',
        page: 'Halaman'
    },
    customerReportColumns: {
        labelName: 'Nama',
        labelTotalTransaction: 'Jumlah Transaksi',
        labelTotalSales: 'Jumlah Jualan',
        labelTotalProfit: 'Jumlah Keuntungan'
    },
    scannerDialog: {
        finished: 'Selesai',
        reduce: 'Kurangkan',
        successfull: 'Berjaya',
        searching: 'Mencari...',
        title: 'Pengimbas aktif. Arahkan ke kod bar!'
    },
    historyFilter: {
        SelectBuyer: 'Pilih Pembeli',
        SelectVendor: 'Pilih Pembekal'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stok Rendah ke Tinggi',
        StockHightoLow: 'Stok Tinggi ke Rendah',
        AlphabetAZ: 'Abjad A-Z',
        AlphabetZA: 'Abjad Z-A'
    },
    minimizeTitle: 'Pengimbas aktif',
    security_guarantee: {
        title: 'Jaminan Keselamatan Data'
    },
    invoice: {
        invoicePlaceholder: 'Nombor Invois',
        invoiceTitle: 'Invois',
        manageInvoiceAddress: 'Urus Alamat Invois',
        selectOrManageAddresses: 'Pilih, edit atau cipta alamat invois tersuai',
        useBusinessProfileAddress: 'Gunakan Alamat Profil Perniagaan',
        noCustomAddressesFound: 'Tiada Alamat Tersuai Ditambah',
        createCustomAddressDesc: 'Tambah alamat bil atau cawangan tersuai untuk dicetak pada invois anda sebagai ganti data profil perniagaan lalai.',
        defaultFromBusinessProfile: 'Lalai Dari Profil Perniagaan',
        editInvoiceAddress: 'Edit Alamat Invois',
        createNewInvoiceAddress: 'Buat Alamat Invois Baharu',
        logoHeaderImage: 'Logo / Imej Pengepala',
        deleteInvoiceAddress: 'Padam Alamat Invois?',
        deleteAddressConfirmText: 'Adakah anda pasti mahu memadam alamat invois ini? Tindakan ini tidak boleh dibatalkan.'
    },
    ManageInvoiceAddress: 'Urus Alamat Invois',
    SelectOrManageAddresses: 'Pilih, edit atau cipta alamat invois tersuai',
    UseBusinessProfileAddress: 'Gunakan Alamat Profil Perniagaan',
    CreateNewAddress: 'Cipta Alamat Baharu',
    UpdatingList: 'Mengemas kini senarai...',
    NoCustomAddressesFound: 'Tiada Alamat Tersuai Ditambah',
    CreateCustomAddressDesc: 'Tambah alamat bil atau cawangan tersuai untuk dicetak pada invois anda sebagai ganti data profil perniagaan lalai.',
    DefaultFromBusinessProfile: 'Lalai Dari Profil Perniagaan',
    EditInvoiceAddress: 'Edit Alamat Invois',
    CreateNewInvoiceAddress: 'Buat Alamat Invois Baharu',
    LogoHeaderImage: 'Logo / Imej Pengepala',
    UploadingImage: 'Memuat naik Imej...',
    UploadImage: 'Muat Naik Imej',
    BusinessName: 'Nama Perniagaan',
    AddressDetails: 'Butiran Alamat',
    PhoneNumber: 'Nombor Telefon',
    EmailAddress: 'Alamat E-mel',
    DeleteInvoiceAddress: 'Padam Alamat Invois?',
    DeleteAddressConfirmText: 'Adakah anda pasti mahu memadam alamat invois ini? Tindakan ini tidak boleh dibatalkan.',

    stocklowreport: {
        no_stocklowreport_one: 'Tiada barang dengan tetapan Stok Keselamatan.',
        no_stocklowreport_two: 'Sila tambah kuantiti Stok Keselamatan.',
        currentStock: 'Stok Semasa',
        safetyStock: 'Stok Keselamatan',
        pricing: 'Penetapan Harga',
        costPrice: 'Harga Kos',
        sellingPrice: 'Harga Jualan',
        productInfo: 'Maklumat Produk',
        category: 'Kategori',
        description: 'Penerangan',
        no_description: 'Tiada penerangan ditambahkan',
        variants: 'Varian',
        unitsOnHand: 'unit dalam stok',
        minimumThreshold: 'ambang minimum',
        adjust: 'Laraskan',
        all: 'Semua',
        lowStock: 'Stok Rendah',
        variantsDetails: 'Butiran Varian',
        qty: 'Kuantiti',
        addSafetyStock: 'Tambah Stok Keselamatan',
        searchByNameSku: 'Cari mengikut nama/SKU',
        safetyStockShort: 'S',
        warehouseSafetyStock: 'Stok Keselamatan Gudang'
    },
    low_alert_stock: 'Masukkan kuantiti stok keselamatan',
    lowStockAlertNotify: "Anda akan menerima notifikasi apabila stok jatuh di bawah kuantiti yang ditetapkan",
    applyButtonStockAlert: 'Guna',
    cancelButtonStockAlert: 'Batal',
    searchProductLabel: 'Cari produk...',
    successfullyAddedSafetyStock: 'Stok Keselamatan berjaya dikemas kini',
    safety_Stock: 'Stok Keselamatan',
    safety_stock_placeholder: 'Masukkan Stok Keselamatan',
    lowStockDetailsInfo: {
        ProductCode: 'Kod Produk',
        SafetyStock: 'Stok Keselamatan',
        Stock: 'Stok',
        CostPrice: 'Harga Kos',
        SellingPrice: 'Harga Jual',
        Category: 'Kategori',
        Description: 'Penerangan',
        ExpirationDate: 'Tarikh Luput'
    },
    CustomLang: {
        Attribute: 'Atribut',
        AddAttribute: 'Tambah Atribut',
        EditAttribute: 'Sunting Atribut',
        CustomLabePlaceholder: 'Masukkan Nama Atribut',
        CustomLabePlaceholderSelect: 'Pilih Jenis',
        AddMoreAttribute: 'Tambah Atribut Lagi',
        ItemAttribute: 'Atribut Barang',
        TableName: 'Nama',
        TableType: 'Jenis',
        TableAction: 'Tindakan',
        TableDelete: 'Padam',
        TableEdit: 'Sunting',
        deleteMessage: 'Atribut Berjaya Dipadam',
        editSuccessMessage: 'Atribut Berjaya Dikemas Kini',
        AddSuccessMessage: 'Atribut Berjaya Ditambah',
        AddAtt: 'Tambah',
        EditAtt: 'Sunting',
        SubmitAtt: 'Sedang Hantar...'
    },
    Expenses: {
        ExpensesTitle: 'Perbelanjaan',
        AddExpenses: 'Tambah Perbelanjaan',
        ExpenseCategory: 'Kategori Perbelanjaan',
        NoExpenseCategory: 'Tiada kategori perbelanjaan',
        AddExpenseCategory: 'Tambah kategori perbelanjaan',
        SelectExpenseCategory: 'Pilih kategori perbelanjaan',
        NoExpenses: 'Tiada Perbelanjaan',
        ExpensesSuccess: 'Perbelanjaan berjaya dicipta',
        ExpensesSuccessEdit: 'Perbelanjaan berjaya dikemas kini',
        ExpensesCategoryName: 'Nama kategori perbelanjaan',
        ExpensesSuccessDelete: 'Perbelanjaan berjaya dipadam',
        AddNEC: 'Tambah Kategori Perbelanjaan Baru',
        NC: 'Kategori Perbelanjaan Baru',
        EditNEC: "Sunting Kategori Perbelanjaan"
    },
    Manufacturing: {
        ProducedProduct: "Produk Diharsipkan",
        QuantityManufactured: "Kuantiti Dikilangkan",
        UnitCost: "Kos Seunit",
        RawMaterialsTotal: "Jumlah Bahan Mentah",
        TotalManufacturingCost: "Jumlah Kos Pembuatan",
        NoRawMaterialsConsumed: "Tiada bahan mentah digunakan.",
        CostBreakdown: "Pecahan Kos",
        GeneratedBatch: "Kelompok Dijana",
        StoredBinLocation: "Lokasi Penyimpanan",
        NoManufacturingTransactionsFound: "Tiada transaksi pembuatan ditemui",
        AddManufacture: 'Tambah Butiran Pembuatan',
        Manufacturing: 'Pembuatan',
        RawMaterials: 'Bahan Mentah',
        AdditonCosts: 'Kos Tambahan',
        RawMaterial: 'Bahan Mentah',
        AdditonCost: 'Kos Tambahan',
        TotalCost: 'Jumlah Kos',
        AddRawMaterial: 'Tambah bahan mentah untuk',
        AddAdditonCost: 'Tambah kos tambahan untuk',
        AddMore: 'Tambah lagi',
        Add: 'Tambah',
        Update: 'Kemas kini',
        Updating: 'Sedang Hantar...',
        ProductRequired: 'Produk diperlukan',
        QuantityRequired: 'Kuantiti diperlukan',
        ChargeRequired: 'Caj diperlukan',
        EstimatedCostRequired: 'Kos Anggaran diperlukan',
        PurchasePriceRequired: 'Harga Pembelian diperlukan',
        SelectCharge: 'Pilih Caj',
        EstimatedCost: 'Kos Anggaran',
        SelectProduct: 'Pilih Produk',
        Quantity: 'Kuantiti',
        ManufactureDetails: 'Butiran Pembuatan',
        BuyingPrice: 'Harga Beli',
        LabourCharge: 'Caj Buruh',
        ElectricityCost: 'Kos Elektrik',
        PackagingCharge: 'Caj Pembungkusan',
        LogisticCost: 'Kos Logistik',
        OtherCharges: 'Caj Lain',
        Save: 'Simpan butiran',
        PurchasePrice: 'Harga Pembelian',
        Date: 'Tarikh',
        For: 'Untuk',
        PurchaseRate: 'Kadar Pembelian (Harga)',
        Scrolltoloadmore: 'Skrol untuk memuat lebih...',
        Noproductsfound: 'Tiada produk ditemui',
        ManufacturingQuantity: 'Kuantiti Pembuatan',
        ManufactureAddedSuccess: 'Butiran Pembuatan berjaya dikemas kini'
    },
    Warehouses: {
        transferOrder: 'Pindah Barang',
        AddTransferOrder: 'Tambah Pindah Barang',
        NewWarehouse: 'Gudang Baru',
        newHead: 'Mulakan pengurusan berbilang gudang!',
        headTwo: 'Jejak dan urus inventori anda merentasi pelbagai gudang dengan lancar',
        EnableWarehouse: 'DAYA AKTIFKAN GUDANG',
        EnableWarehouse2: 'Dayakan Gudang',
        OrganizationPrimary: 'Utama Organisasi',
        Edit: 'Sunting',
        AreEnableWarehouse: 'Adakah anda pasti mahu mendayakan gudang?',
        Confirm: 'Sahkan',
        Cancel: 'Batal',
        WarehouseCreatedSuccessfully: 'Gudang berjaya dicipta',
        MarkAsOP: "Tandakan sebagai Utama Organisasi",
        MarkAsInAct: 'Tandakan sebagai Tidak Aktif',
        MarkAsAct: 'Tandakan sebagai Aktif',
        MarkedAsInactive: 'Gudang berjaya ditandakan tidak aktif',
        MarkedAsActive: 'Gudang berjaya ditandakan aktif',
        MarkedAsOP: 'Gudang berjaya ditandakan sebagai utama organisasi',
        WareDeletedSuccess: 'Gudang berjaya dipadam',
        SuccessfullyUpdatedWarehouse: 'Gudang berjaya dikemas kini',
        SuccessfullyCreatedWarehouse: 'Gudang berjaya dicipta',
        EditWarehouse: 'Sunting Gudang',
        AddWarehouse: 'Tambah Gudang',
        WarehouseNameIsRequired: 'Nama Gudang diperlukan',
        EnterWarehouseName: 'Masukkan nama gudang',
        EnterEmail: 'Masukkan emel',
        EnterPhoneNumber: 'Masukkan nombor telefon',
        Location: 'Lokasi...',
        name: 'Nama gudang',
        email: 'Emel',
        phoneNumber: 'Nombor telefon',
        location: 'Lokasi',
        ViewProducts: 'Lihat Produk',
        PageTitle: 'Gudang',
        noWarehouse: "Tiada gudang yang sepadan dengan carian anda"
    },
    Assets: {
        headerTitle: 'Aset',
        addAssetMessage: "Tambah aset di sini. Untuk tetapkan aset kepada kakitangan, pergi ke profil ahli kakitangan tersebut.",
        addAsset: 'Tambah Aset',
        editAsset: 'Sunting Aset',
        assetCode: 'Kod Aset',
        assetName: 'Nama Aset',
        assetCategory: 'Kategori Aset',
        assetType: 'Jenis Aset',
        serialNumber: 'Nombor Siri',
        location: 'Lokasi',
        condition: 'Keadaan',
        selectCondition: 'Pilih Keadaan',
        fair: 'Sederhana',
        good: 'Baik',
        excellent: 'Cemerlang',
        poor: 'Buruk',
        notes: 'Nota',
        submit: 'Hantar',
        submitting: 'Sedang Hantar',
        noCategory: 'Tiada kategori',
        selectCategory: 'Pilih kategori',
        addAssetCat: 'Tambah Kategori Aset',
        addAssetCatName: 'Nama kategori aset',
        edit: 'Sunting',
        status: 'Status',
        createdAt: 'Dicipta Pada',
        viewAsset: 'Lihat Aset',
        assignAsset: 'Tetapkan Aset',
        conditionRet: 'Keadaan (Semasa Pemulangan)',
        searchSelectAssets: 'Cari/Pilih Aset',
        assetAssigned: 'Aset berjaya ditetapkan',
        assetReturned: 'Aset berjaya dipulangkan',
        selectAnAsset: 'Sila pilih aset',
        action: 'Tindakan',
        noAssetAssigned: 'Tiada aset ditetapkan',
        reAssigned: 'Tetapkan semula',
        assignedAssetsList: 'Senarai Aset yang Ditugaskan',
        viewHistory: 'Lihat Sejarah',
        history: 'Sejarah Aset',
        loadingHistory: 'Memuat sejarah...',
        loadingMore: 'Memuat lagi...',
        dateTime: 'Tarikh & Masa',
        staff: 'Kakitangan',
        AssignedBy: 'Ditugaskan Oleh',
        assign: 'TUGASKAN',
        return: 'PULANGKAN',
        unknown: 'TIDAK DIKETAHUI',
        noHistory: 'Tiada sejarah tersedia untuk aset ini.',
        enterReturnNote: 'Masukkan nota pemulangan',
        returnNote: 'Nota Pemulangan',
        enterAssignNote: 'Masukkan nota penugasan',
        assignNote: 'Nota Penugasan',
        AddNAC: "Tambah Kategori Aset Baru",
        EditNAC: "Sunting Kategori Aset",
        others: "Lain-lain"
    },
    LedgerTransaction: {
        ledgerDetails: 'Butiran Lejar',
        productName: 'Nama Produk',
        totalQty: 'Jumlah Kuantiti',
        date: 'Tarikh',
        receivedAmt: 'Amaun Diterima',
        paid: 'Dibayar',
        discount: 'Diskaun',
        balance: 'Baki',
        more: 'lagi',
        total: 'Jumlah',
        ledgerupdatedsuccessfully: 'Lejar berjaya dikemas kini',
        ledgeraddedsuccessfully: 'Lejar berjaya ditambah',
        viewLedger: 'Lihat Lejar',
        edit: 'Sunting',
        create: 'Cipta',
        Recieved: 'Diterima [stok masuk]',
        payMode: 'Mod Pembayaran',
        Refno: 'No Rujukan'
    },
    ExtraField: {
        attachment: 'Lampiran',
        acceptOnlyImg: 'Hanya terima imej.',
        addAttribute: 'Tambah Atribut',
        acceptImgAndDoc: 'Terima imej dan dokumen.'
    },
    phoneInvoiceDownload: {
        Variant: 'Varian',
        Warehouse: 'Gudang',
        Bin: 'Lokasi Bin',
        Batch: 'Kumpulan',
        Attributes: 'Atribut'
    },
    ImportExcel: {
        ImportStockfromExcel: "Import Stok dari Excel",
        DragDrop: "Seret & lepas fail Excel yang telah diisi di sini, atau klik untuk semak imbas",
        DT: "Muat Turun Template",
        GB: "Kembali",
        Downloading: "Sedang memuat turun...",
        ChangeFile: "Tukar Fail",
        ReadingExcelfile: "Membaca fail Excel...",
        Processing: "Memproses...",
        submitUpdateStock: "Hantar & Kemaskini Stok",
        downloadLatestTemplate: "Muat Turun Template Terkini",
        loginRequired: "Log Masuk Diperlukan"
    },
    stockForm: {
        recordPaymentNow: "Rekod pembayaran sekarang",
        recordPaymentDescCustomer: "Masukkan jumlah yang dibayar oleh pelanggan",
        recordPaymentDescSupplier: "Masukkan jumlah yang dibayar oleh pembekal",
        managePayments: "Urus Pembayaran",
        invoice: "Invois",
        challan: "Challan",
        recordPayment: "Rekod Pembayaran",
        payableAmount: "Amaun Boleh Bayar",
        paidAmount: "Amaun Dibayar",
        paymentMethod: "Kaedah Pembayaran",
        paymentDate: "Tarikh Pembayaran",
        reference: "Rujukan",
        billId: "Nombor Bil",
        importExcel: "Import dari Excel",
        noThanks: "Tidak, Terima Kasih",
        checkHistory: "Semak Sejarah Anda",
        wantViewHistory: "Adakah anda mahu melihat sejarah anda?",
        enterPayable: 'Masukkan Amaun Boleh Bayar',
        enterPaid: 'Masukkan Amaun Dibayar',
        selectPayment: "Pilih Kaedah Pembayaran",
        attachment: "Lampiran",
        note: "Nota"
    },
    HistoryEdit: {
        products: "Produk",
        add_product: "Tambah Produk",
        paidAmountInvalidMessage: 'Amaun dibayar tidak boleh melebihi amaun boleh bayar',
        removingText: "Memadam produk ini akan membatalkan perubahan stok yang dibuat semasa transaksi ini.",
        remove: "Padam",
    },
    ExcelProduct: {
        uploadFile: "Muat Naik Fail",
        dragDrop: "Seret dan lepaskan fail Excel anda, atau klik untuk memuat naik.",
        parsingFile: "Menganalisis fail",
        fileSelected: "Fail dipilih",
        reviewImportedData: "Semak data yang diimport di bawah. Lajur dipadankan secara automatik jika boleh.",
        changeFile: "Tukar Fail",
        back: "Kembali",
        invalidFileType: "Sila muat naik fail Excel yang sah (.xlsx atau .xls)",
        parseExcelError: "Ralat menganalisis Excel:",
        noData: "Fail Excel yang dimuat naik tiada data.",
        failedToRead: "Gagal membaca fail Excel. Sila cuba lagi.",
        Nodata: "TIADA_DATA",
        unableToRead: "Tidak dapat membaca fail.",
        buyingMustNumber: "Harga Beli mesti nombor",
        sellingMustNumber: "Harga Jual mesti nombor",
        mustBeNumber: "mesti nombor",
        bulkUploadfailed: "Muat naik pukal gagal",
        importFromExcel: "Import dari Excel",
        generating: "Sedang menjana...",
        downloadTemplate: "Muat Turun Templat",
        uploading: "Sedang memuat naik...",
        done: "Selesai",
        requiredField: "{field} diperlukan",
        bulkUpload: "Muat Naik Pukal",
        duplicateSku: "SKU pendua ditemui",
        uploadedSuccessfully: "Semua produk berjaya dimuat naik!",
        uploadCompleteIssues: "Muat naik selesai dengan isu",
        uploaded_products: "{count} produk dimuat naik.",
        failed_products: "{count} gagal.",
        failed_items: "Item gagal:"
    },
    ProductForm: {
        barcodeQuantity: "Masukkan Kuantiti Kod Bar",
        baseUnit: "Unit Asas (Utama)",
        addSecondaryUnit: "Tambah Unit Sekunder?",
        selectUnit: "Pilih Unit",
        subUnitDetails: "Butiran Unit Sekunder",
        subUnit: "Unit Sekunder",
        selectSubUnit: "Pilih Unit Sekunder",
        conversionRate: "Kadar Penukaran",
        exampleLogic: "Contoh logik:",
        example: "Jika anda menjual pen dalam kotak, tetapkan Unit Asas sebagai Kotak dan tambah Unit Sekunder keping dengan kadar penukaran 50. Ini bermakna 1 Kotak mengandungi 50 keping.",
        basePrice: "Harga Asas",
    },
    barcode: {
        settings: 'Tetapan Barkod',
        labelSize: 'Saiz label',
        customSize: 'Saiz tersuai...',
        widthMm: 'Lebar (mm)',
        heightMm: 'Tinggi (mm)',
        showPrice: 'Papar harga jualan pada label',
        noPrices: 'Tiada harga jualan dikonfigurasikan untuk produk ini.',
        preview: 'Pratonton',
        generate: 'Jana',
        label: 'label',
        singlePage: 'Halaman Tunggal',
        downloadOptions: 'Pilihan Muat Turun',
        chooseLayout: 'Pilih reka letak untuk barkod',
        allInSinglePage: 'Tambah semua barkod dalam satu halaman.',
        allInA4Grid: 'Semua dalam Halaman Tunggal',
        allInA4GridSub: 'Menyusun semua barkod dalam grid A4',
        onePerPage: 'Satu Setiap Halaman',
        onePerPageSub: 'Setiap barkod pada halaman label sendiri'
    },

    Discount: {
        overallDiscount: "Diskaun Keseluruhan",
        final: 'Akhir',
        balanceDue: "Baki Tertunggak",
        tax: "Cukai",
    },
    TransferItem: {
        transferItem: 'Pindah Barang',
        Date: 'Tarikh',
        Reason: 'Sebab',
        enterReason: "Masukkan Sebab",
        Name: 'Nama',
        QuantityTransfered: 'Kuantiti Dipindah',
        SWarehouse: 'Gudang Sumber',
        SelectSWarehouse: 'Pilih Gudang Sumber',
        DWarehouse: 'Gudang Destinasi',
        SelectDWarehouse: 'Pilih Gudang Destinasi',
        CreatedBy: 'Dicipta Oleh',
        CreatedTime: 'Masa Dicipta',
        UpdatedTime: 'Masa Dikemas Kini',
        NoOrderFound: 'Tiada Pesanan Ditemui',
        New: 'Baru',
        WarehouseItemTransfer: 'Pemindahan Barang Gudang',
        TotalTransfers: "Jumlah Pemindahan",
        EnterReason: 'Masukkan Sebab',
        ItemDetails: 'Butiran Barang',
        CurrentAvailable: 'Ketersediaan Semasa',
        TransferQty: 'Kuantiti Dipindah',
        SStock: 'Stok Sumber',
        DStock: 'Stok Destinasi',
        addDescription: "Tambah penerangan untuk barang anda",
        selectVariant: "Pilih varian",
        addNewRow: "Tambah baris baru",
        typeOrSelectItem: "Taip untuk mencari",
        scrollToLoadMore: "Skrol untuk memuat lebih banyak",
        noProductsFound: "Tiada produk ditemui",
        selectWarehouse: "Pilih gudang"
    },
    Sku: {
        searchSelectProduct: "Cari/Pilih Produk",
        searchSelectSku: "Cari/Pilih SKU",
        noSkuFound: "Tiada SKU ditemui"
    },
    HistoryPage: {
        addFilter: "Tambah Penapis",
        filtersActive: "Semua penapis aktif",
        noProducts: "Tiada produk",
        download: "Muat Turun",
        recentlyUpdated: "Baru Dikemas Kini",
    },
    StockPage: {
        challanNumber: "Nombor Challan",
        subTotal: "Sub Jumlah",
        totalTaxes: "Jumlah & Cukai",
        taxInclusive: "Cukai Termasuk",
        discountedValue: "Nilai Selepas Diskaun",
        taxValue: "Nilai Cukai",
        totalAmount: "Jumlah Amaun",
        close: "Tutup",
        addTax: "Tambah Cukai",
        label: "Label",
        enterLabel: "Masukkan Label",
        taxRate: "Kadar Cukai",
        enterTaxRate: "Masukkan kadar cukai",
        selectTaxRate: "Pilih kadar cukai",
        addNewTax: "Tambah kadar cukai baru",
        discountProducts: "Nilai Diskaun (Produk)",
        taxProducts: "Nilai Cukai (Produk)",
        clickAddPayment: "Klik untuk tambah pembayaran",
        paidGreaterPayable: "Amaun dibayar tidak boleh melebihi amaun boleh bayar",
        vendorCompulsory: 'Pembekal diperlukan untuk merekod pembayaran',
        customerCompulsory: "Pelanggan diperlukan untuk merekod pembayaran",
        updateInvoiceFormat: "Kemas kini Format Invois",
        updateChallanFormat: "Kemas kini Format Challan",
        addPrefix: "Tambah Awalan",
        prefix: "Awalan"
    },
    EditHistoryPage: {
        search_by_notes: "Cari mengikut Nota",
        alertMessage: "Perubahan ini hanya direkod dalam sejarah dan tidak mempengaruhi stok produk semasa.",
        paymentDetails: "Butiran Pembayaran",
        units: "Unit",
        customLabels: "Label Tersuai",
        value: "Nilai",
        Order_Info: "Maklumat Pesanan",
        percentage: "Peratus",
        Stock_updates_on_submit: "Kemas kini stok semasa hantar",
        Summary: "Ringkasan",
    },
    historyCard: {
        paid: "DIBAYAR",
        partiallyPaid: "SEBAHAGIAN DIBAYAR",
        billDate: "Tarikh Bil",
        productDetails: "Butiran Produk",
        paymentsHistory: "Sejarah Pembayaran",
        updatePayment: "Kemas kini Pembayaran",
        discounts: "Diskaun",
        inclusive: "(termasuk)",
        discountOverall: "Nilai Diskaun (Keseluruhan)",
        dueAmount: "Amaun Tertunggak",
        enterPaid: "Masukkan Amaun Dibayar",
        enterReference: "Masukkan Rujukan",
        enterNote: "Masukkan Nota",
        enterInvoice: "Masukkan Invois",
        enterChallan: "Masukkan Challan",
        edit: "Diedit"
    },
    printInvoice: {
        billTo: "Bil Kepada",
        ref: "No. Ruj",
        mode: "Mod",
        date: "Tarikh",
        amount: "Amaun",
        totalPaid: "Jumlah Dibayar",
        noImage: "Tiada Gambar"
    },
    Contact: {
        supplier_required: "Pembekal diperlukan untuk stok masuk",
        customer_required: "Pelanggan diperlukan untuk stok keluar",
        key: "Kunci",
        editHistory: "Sunting Sejarah",
        loading: "Memuat..."
    },
    AW: {
        availablewarehouse: "Gudang Tersedia",
        visibilityManagement: 'Pengurusan Keterlihatan',
        availablewarehouses: "Gudang Tersedia",
        Active: "Aktif",
        LWarehouse: "Memuat Gudang...",
        NWForthisProduct: "Tiada gudang ditemui untuk produk ini.",
        of: "daripada",
        WarehouseAvailabilty: "Ketersediaan Gudang",
    },
    Currency: {
        searchCurrency: "Cari Mata Wang...",
        addCurrency: "Tambah Mata Wang",
        addNewCurrency: "Tambah Mata Wang Baru",
        editCurrency: "Sunting Mata Wang",
        currencySymbol: "Simbol Mata Wang",
        currencyName: "Nama Mata Wang",
        enterCurrencySymbol: "Masukkan Simbol Mata Wang",
        enterCurrencyName: "Masukkan Nama Mata Wang"
    },
    NewReportLang: {
        DM: "Pergerakan Harian",
        WR: "Laporan Gudang",
        PDM: "Pergerakan Harian Produk",
        TBP: "Jumlah Harga Belian",
        TPQ: "Jumlah Kuantiti Produk",
        TP: "Jumlah Produk",
        CS: "Stok Semasa",
        IV: "Nilai Inventori",
        DA: "Purata Harian",
        TSI: "Jumlah Stok Masuk",
        TSO: "Jumlah Stok Keluar",
        TOR: "Kadar Pusing Ganti",
        Tv: "Jumlah Nilai",
        AST: "Penjejakan SKU Aktif",
        UT: "Unit Dijejak",
        SL: "Tahap Stok",
        Value: "Nilai",
        IO: "MASUK/KELUAR",
        T: "Pusing Ganti",
        unitsD: "Unit/Hari",
        Sort: "Isih",
        Sort_by: "Isih mengikut",
        Units_available: "Unit Tersedia",
        Units_unavailable: "Unit Tidak Tersedia",
        Current_assets: "Aset Semasa",
        Search: "Cari",
        available: "Tersedia",
        assigned: "Ditugaskan",
        AYSWD: "Adakah anda pasti mahu memadam?",
        PTS: "Gudang berjaya dipindahkan",
        AUS: "Aset berjaya dikemas kini",
        ACS: "Aset berjaya dicipta",
        VSP: "Lihat harga jualan",
        HUS: "Sejarah berjaya dikemas kini",
    },
    ReplacementReturn: {
        selectProduct: "Sila pilih produk",
        selectReplacementProduct: "Pilih sekurang-kurangnya satu produk pengganti",
        validQuantity: "Masukkan kuantiti pulangan yang sah",
        replacedSuccessfully: "Produk berjaya diganti",
        returnSuccessfully: "Produk berjaya dipulangkan",
        failedProcess: "Gagal memproses. Sila cuba lagi.",
        return: "Pulangan",
        replace: "Ganti",
        typeSelectProduct: "Taip atau pilih produk...",
        returnQuantity: "Kuantiti Pulangan",
        enterQuantity: "Masukkan Kuantiti",
        replacementDate: "Tarikh Penggantian",
        returnDate: "Tarikh Pulangan",
        chooseCustomer: "Pilih Pelanggan",
        additionalNotes: "Tambah nota tambahan...",
        replacementProducts: "Produk Pengganti",
        addProducts: "Tambah Produk Lagi",
        tapSelect: "Ketuk untuk pilih dari produk yang ada",
        currently: "Buat masa ini",
        item: "item",
        items: "item",
        selected: "dipilih",
        selectedItems: "Item yang dipilih",
        hideDetails: "Sembunyikan butiran lanjut",
        showDetails: "Tunjukkan butiran lanjut",
        product: "produk",
        priceLevel: "Pilih tahap harga",
        customPrice: "Masukkan harga tersuai",
        noReplaceHistory: "Tiada sejarah penggantian ditemui",
        replaceReturn: "Ganti dan Pulangkan",
        replaceReturnHistory: "Sejarah Penggantian & Pemulangan"
    },
    OtherComponent: {
        mfgHistoryTitle: "Sejarah Pembuatan",
        mfgHistoryDesc: "Jejak produk stok yang dikeluarkan",
        dailyOperation: "Operasi Harian",
        freqUsed: "Tindakan yang kerap digunakan untuk mengemas kini rekod dengan cepat",
        manageCategory: "Urus Kategori",
        organizeCaterory: "Susun dan urus kategori produk, perbelanjaan dan aset",
        businessRecord: "Rekod Perniagaan",
        organizeRecord: "Susun dan urus rekod perniagaan anda",
        trackHistory: "Jejak Sejarah",
        completeTracking: "Sejarah lengkap untuk audit dan penjejakan",
        Verifyinventorycount: "Sahkan kiraan inventori",
        Exchangerates: "Kadar pertukaran",
        Productiontracking: "Penjejakan pengeluaran",
        Fixedassetregister: "Daftar aset tetap",
        Storagelocations: "Lokasi penyimpanan",
        warehouseAvailability: 'Ketersediaan produk peringkat gudang',
        Logreviewspend: "Log dan semak perbelanjaan",
        Productgroupings: "Pengelompokan produk",
        Classifyexpenditures: "Klasifikasikan perbelanjaan",
        Assetclassification: "Klasifikasi aset",
        Manageexchanges: "Urus pertukaran",
        Returnauditlog: "Log audit pemulangan",
        Interlocationmoves: "Pergerakan antara lokasi",
        Manageoperationscategoriesrecordsandhistory: "Urus operasi, kategori, rekod dan sejarah"
    },
    no_permission_dialog: {
        title: 'Tiada Kebenaran',
        historyDescription: "Anda tidak mempunyai kebenaran untuk melihat Sejarah Transaksi. Sila hubungi pentadbir anda.",
        replacementHistoryDescription: "Anda tidak mempunyai kebenaran untuk melihat Sejarah Penggantian & Pemulangan. Sila hubungi pentadbir anda.",
        transferHistoryDescription: "Anda tidak mempunyai kebenaran untuk melihat Sejarah Pindah Gudang. Sila hubungi pentadbir anda."
    },
    OthersHistory: {
        title: "Urus Sejarah",
        transferHistory: "Urus Sejarah Pindah",
        transactionHistory: "Urus Sejarah Transaksi",
        replacementHistory: "Urus Sejarah Penggantian dan Pemulangan"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "Lihat dan beli produk yang dikongsi oleh perniagaan.",
        description: "Lihat produk yang dikongsi oleh perniagaan.",
        productsAvailable: "Produk tersedia",
        noImageAvailable: "Tiada imej tersedia",
        productDetails: "Butiran produk",
        inStock: "dalam stok",
        availableVariants: "Pilihan tersedia",
        options: "pilihan",
        orders: "Pesanan"
        ,
        searchProducts: "Cari produk...",
        noProductsFound: "Tiada produk dijumpai",
        tryDifferentKeyword: "Cuba cari dengan kata kunci lain",
        variants: "Varian",
        stock: "Stok",
        cart: "Troli",
        products: "Produk",
        viewCart: "Lihat Troli",
        backToProducts: "Kembali ke Produk",
        yourCart: "Troli Anda",
        clear: "Kosongkan",
        cartEmpty: "Troli anda kosong",
        cartEmptyDesc: "Layari katalog dan tambah produk yang ingin dipesan.",
        browseProducts: "Layari Produk",
        selectedItems: "Item Terpilih",
        itemInCart: "item dalam troli",
        itemsInCart: "item dalam troli",
        customerDeliveryDetails: "Butiran Pelanggan & Penghantaran",
        fullName: "Nama Penuh",
        enterFullName: "Masukkan nama penuh anda",
        deliveryAddress: "Alamat Penghantaran",
        addressPlaceholder: "Alamat jalan, bangunan, bandar, poskod...",
        orderNote: "Nota Pesanan (Pilihan)",
        orderNotePlaceholder: "Arahan khas atau nota penghantaran...",
        paymentMode: "Mod Pembayaran",
        subtotal: "Subjumlah",
        items: "item",
        totalAmount: "Jumlah Keseluruhan",
        orderOnWhatsApp: "Pesan melalui WhatsApp 📲",
        orderPlaced: "Pesanan Berjaya Dibuat! 🎉",
        orderPlacedDesc: "Pesanan anda telah direkodkan dan WhatsApp telah dibuka.",
        continueShopping: "Teruskan Membeli 🛍️",
        cartEmptyTitle: "Troli Kosong",
        cartEmptyToast: "Sila tambah produk sebelum checkout.",
        incompleteTitle: "Maklumat Tidak Lengkap",
        incompleteToast: "Sila isi semua medan yang diperlukan.",
        nameRequired: "Nama penuh diperlukan",
        addressRequired: "Alamat penghantaran diperlukan",
        catalogUnavailable: "Katalog Tidak Tersedia",
        catalogUnavailableDesc: "Katalog ini tidak aktif buat masa ini. Hubungi perniagaan.",
        invalidCatalogLink: "Pautan Katalog Tidak Sah 🚫",
        invalidCatalogDesc: "Halaman katalog ini kekurangan maklumat yang diperlukan.",
        missing: "Hilang",
        catalogSlug: "Slug Katalog",
        goBackHome: "Kembali ke Laman Utama",
        inventoryManagement: "Pengurusan Inventori & Invois 🚀 Simply",
        enter: "Masukkan",
        select: "Pilih",
        // Catalog Order translations
        catalogOrders: 'Pesanan Katalog',
        pending: 'Belum selesai',
        converted: 'Ditukar',
        cancelled: 'Dibatalkan',
        totalRevenue: 'Jumlah Nilai',
        totalCatalogOrders: 'Jumlah Pesanan Dalam Talian',
        convertToSalesOrder: 'Tukar ke Pesanan Jualan',
        date: 'Tarikh',
        status: 'Status',
        action: 'Tindakan',
        searchOrders: 'Cari pelanggan atau telefon...',
        noMatchingOrders: 'Tiada pesanan sepadan',
        noStatusOrders: 'Tiada pesanan {status} ditemui',
        tryDifferentSearch: 'Cuba cari dengan nama pelanggan atau nombor telefon yang berbeza.',
        noOrdersWithStatus: 'Pada masa ini tiada pesanan dengan status {status}.',
        noOrdersYet: 'Belum Ada Pesanan Katalog',
        noOrdersDescription: 'Pesanan yang dibuat dari katalog dalam talian anda akan dipaparkan di sini.',
        guestCustomer: 'Pelanggan Tetamu',
        item: 'Item',
        moreItems: '+{count} lagi',
        viewDetails: 'Lihat Butiran',
        viewSalesOrder: 'Lihat Pesanan Jualan',
        cancelOrder: 'Batalkan Pesanan',
        confirmCancelTitle: 'Batalkan Pesanan Katalog?',
        confirmCancelOrder: 'Adakah anda pasti mahu membatalkan pesanan ini? Tindakan ini tidak boleh dibuat asal.',
        keepOrder: 'Tidak, Kekalkan Pesanan',
        confirmCancelAction: 'Ya, Batalkan Pesanan',
        orderNotFound: 'Pesanan Katalog Tidak Ditemui',
        orderNotFoundDescription: 'Pesanan ini tidak dapat ditemui atau anda mungkin tidak mempunyai kebenaran untuk melihatnya.',
        backToCatalogOrders: 'Kembali ke Pesanan Katalog',
        placedOn: 'Dipesan pada',
        totalItems: 'Jumlah Item',
        orderedProducts: 'Produk Dipesan',
        itemDetails: 'Butiran Item',
        quantity: 'Kuantiti',
        unitPrice: 'Harga Unit',
        total: 'Jumlah',
        variant: 'Varian',
        customerInformation: 'Maklumat Pelanggan',
        additionalFields: 'Medan Tambahan',
        fields: 'medan',
    },
    stockNew: {
        Npay: "Belum ada produk ditambah lagi",
        emptydesc: "Pilih produk dari katalog anda dan masukkan kuantiti masuk untuk merekod stok.",
        tipText: "Petua: Anda juga boleh muat naik fail excel",
        OT: "Jumlah Pesanan",
        Collapse: "Runtuh"
    },
    deleteBulk: {
        Bulkoperation: "Operasi Pukal",
        Applyproducts: "Gunakan tindakan pada pelbagai produk",
        Bulkupload: "Muat Naik Pukal",
        ImportCSVfile: "Import produk melalui fail Excel atau CSV",
        or: "atau",
        Bulkdelete: "Padam Pukal",
        Permanentlyallproducts: "Buang semua produk secara kekal",
        IrrText: "Padam pukal tidak boleh dibatalkan. Eksport sandaran terlebih dahulu jika perlu.",
        SeP: "Produk Terpilih",
        sP: "Pilih Produk",
        DA: "Padam Semua",
        DP: "Padam Produk",
        sL: "Pilih Semua",
        ASDE: "Anda pasti mahu memadam semua produk kecuali",
        ASDAllP: "Anda pasti mahu memadam semua produk?",
        ASD: "Anda pasti mahu memadam",
        products: "produk",
        TACBU: "Tindakan ini tidak boleh dibatalkan.",
        LP: "Memuat produk...",
        FM: "Mengambil lagi...",
        NPF: "Tiada produk ditemui.",
        LMP: "Memuat lagi produk..."
    },
    NewVariantModal: {
        Definevariantsassign: "Tentukan varian & tetapkan kuantiti",
        Nothingallocated: "Tiada yang diperuntukkan",
        Overallocated: "Diperuntukkan berlebihan",
        Fullyallocated: "Diperuntukkan sepenuhnya",
        Overby: "Lebih oleh",
        Allvariantsneedaname: "Semua varian memerlukan nama.",
        Reducequantities: "Kurangkan kuantiti.",
        Overallocatedby: "Diperuntukkan berlebihan sebanyak",
        Quantitiesmustmatchthetotalavailability: "Kuantiti mesti sepadan dengan jumlah ketersediaan.",
        Allocatequantitiesacrosswarehouses: "Peruntukkan kuantiti merentasi gudang",
        Notfullydistributed: "Tidak sepenuhnya diedarkan:",
        remaining: "baki",
        Qty: "Kuantiti",
        Inactive: "Tidak Aktif",
        left: "baki"
    },
    ProductFormNew: {
        BasicInfo: "Maklumat Asas",
        ProductImage: "Imej Produk",
        Images: "Imej",
        Pricing: "Harga",
        Everypriceneedsbothalabelandanamount: "Setiap harga memerlukan label dan jumlah",
        AddalabellikeWholesaleorRetailtoidentifythisprice: 'Tambah label seperti "Pemborong" atau "Runcit" untuk mengenal pasti harga ini',
        AddMultiplePrice: "Tambah Berbilang Harga",
        NoPhotosLetAiFind: "Tiada foto? Biarkan AI mencari imej produk",
        AddProductImagesTitle: "Tambah Imej Produk",
        ChooseHowToAddPhotos: "Pilih cara anda mahu menambah foto untuk produk ini:",
        SearchWithAi: "Cari dengan AI",
        SearchWithAiDesc: "Cari & pilih imej produk secara automatik menggunakan AI",
        FilesFileExplorer: "Fail (Penjelajah Fail)",
        FilesFileExplorerDesc: "Pilih imej terus dari komputer anda",
        AiProductImageFinder: "Pencari Imej Produk AI",
        AiProductImageFinderDesc: "Cari & pilih imej untuk produk anda",
        TypeProductNamePlaceholder: "Taip nama produk...",
        SearchForYourProduct: "Cari produk anda",
        SearchForYourProductHint: `Cuba nama jenama atau produk, contoh "Kirkland Minoxidil"`,
        ImagesSelected: "imej dipilih",
        AddSelected: "Tambah yang Dipilih"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Tentukan medan tersuai baharu",
        AttributeName: "Nama Atribut",
        DataType: "Jenis Data",
        Noattributesfound: "Tiada atribut ditemui",
        ManageAttributes: "Urus Atribut",
        Editordeleteexistingattributes: "Edit atau padam atribut sedia ada",
        UpdateAttribute: "Kemas kini Atribut",
        Saving: "Menyimpan..."
    },
    NewExpenses: {
        Noexpensesyet: "Belum ada perbelanjaan",
        Addyourfirstexpensetostarttrackingyourspending: "Tambah perbelanjaan pertama anda untuk mula menjejaki perbelanjaan.",
        TOTALEXPENSES: "JUMLAH PERBELANJAAN",
        ENTRIES: "ENTRI",
        BYCATEGORY: "MENGIKUT KATEGORI",
        Nocategoriestodisplay: "Tiada kategori untuk dipaparkan",
        DateanfTime: "Tarikh & Masa"
    },
    PurchaseSales: {
        CancelOrder: "Batalkan pesanan",
        ReopenOrder: "Buka semula pesanan",
        Reopen: "Buka semula",
        ConfirmCancelOrder: "Adakah anda pasti mahu membatalkan pesanan ini?",
        ConfirmReopenOrder: "Adakah anda pasti mahu membuka semula pesanan ini?",
        OrderCancelledSuccessfully: "Pesanan berjaya dibatalkan.",
        OrderReopenedSuccessfully: "Pesanan berjaya dibuka semula.",
        CancelledBy: "Dibatalkan oleh",
        Cancelled: "Dibatalkan",
        ConvertPriceBasedOnUnitConversion: "Tukar Harga Berdasarkan Penukaran Unit",
        MarkPaymentAsPending: "Tandakan Pembayaran sebagai Tertunda",
        PendingReceivableDesc: "Jumlah direkodkan sebagai belum terima. Rekodkan pembayaran apabila diterima.",
        PendingPayableDesc: "Jumlah direkodkan sebagai belum bayar. Rekodkan pembayaran apabila dibayar.",
        SelectCustomerFirst: "Pilih pelanggan terlebih dahulu",
        SelectSupplierFirst: "Pilih pembekal terlebih dahulu",
        SelectItemsFirst: "Sila pilih sekurang-kurangnya satu item terlebih dahulu",
        PaymentMarkedPendingDesc: "Pembayaran ditandakan sebagai tertunda. Nyahtanda 'Tandakan Pembayaran sebagai Tertunda' untuk merekod pembayaran sekarang.",
        SelectCustomerAndItemFirst: "Sila pilih pelanggan dan sekurang-kurangnya satu item terlebih dahulu",
        SelectSupplierAndItemFirst: "Sila pilih pembekal dan sekurang-kurangnya satu item terlebih dahulu",
        SelectCustomerProductFirst: "Pilih pelanggan & produk terlebih dahulu",
        SelectSupplierProductFirst: "Pilih pembekal & produk terlebih dahulu",
        Receivables: "Piutang",
        Payables: "Pemiutang",
        AccessDenied: "Akses Ditolak",
        YouDonthaeP: "Anda tidak mempunyai kebenaran untuk melihat halaman ini. Jika anda rasa ini kesilapan, sila hubungi pentadbir anda.",
        purchase: "Pembelian",
        sales: "Jualan",
        Areyousureyouwantto: "Adakah anda pasti mahu",
        Thisactionwillupdateitsstatus: "Tindakan ini akan mengemas kini statusnya.",
        ReasonOPtional: "Sebab (Pilihan)",
        Enterareasonfor: "Masukkan sebab untuk",
        optionalDot: "(pilihan)...",
        Reject: "Tolak",
        ConfirmOrder: "Sahkan Pesanan",
        RejectOrder: "Tolak Pesanan",
        Previous: "Sebelumnya",
        First: "Pertama",
        Order: "Pesanan",
        Items: "Item",
        Memo: "Memo",
        SelectDateRange: "Pilih Julat Tarikh",
        List: "Senarai",
        Board: "Papan",
        View: "Lihat",
        CreateSalesOrder: "Cipta Pesanan Jualan",
        CreatePurchaseOrder: "Cipta Pesanan Pembelian",
        successfully: "berjaya",
        ManageAttachments: "Urus Lampiran",
        Stockoutitemsimmediatelyaftersaving: "Keluar stok item serta-merta selepas menyimpan.",
        Stockinitemsimmediatelyaftersavingthisorder: "Masuk stok item serta-merta selepas menyimpan pesanan ini.",
        ViewAttachments: "Lihat Lampiran",
        MemoAttachments: "Memo & Lampiran",
        ReceivedDate: "Tarikh Diterima",
        ShippedDate: "Tarikh Dihantar",
        OrderDate: "Tarikh Pesanan",
        OrderDetails: "Butiran Pesanan",
        Subtotal: "Subjumlah",
        OrderSummary: "Ringkasan Pesanan",
        AddItem: "Tambah Item",
        NewSalesOrder: "Pesanan Jualan Baru",
        NewPurchaseOrder: "Pesanan Pembelian Baru",
        Createandmanageyour: "Cipta dan urus",
        orders: "pesanan anda",
        Removeitem: "Buang item",
        UnitPrice: "Harga Unit",
        PurchaseOrder: "Pesanan Pembelian",
        SalesOrder: "Pesanan Jualan",
        PurchaseInvoice: "Invois Pembelian",
        SalesInvoice: "Invois Jualan",
        PurchaseOrdernotfound: "Pesanan Pembelian tidak ditemui",
        Approve: "Luluskan",
        MarkasShipped: "Tandakan sebagai Dihantar",
        MarkasReceived: "Tandakan sebagai Diterima",
        Marking: "Menandakan...",
        PartiallyShip: "Penghantaran Sebahagian",
        PartiallyReceive: "Penerimaan Sebahagian",
        Deleting: "Memadam...",
        Transaction: "Transaksi",
        Details: "Butiran",
        Item: "Item",
        Received: "Diterima",
        Shipped: "Dihantar",
        Ordered: "Dipesan",
        units: "unit",
        Overalldiscount: "Diskaun Keseluruhan",
        Transactions: "Transaksi",
        Notransactionsfound: "Tiada transaksi ditemui",
        OrderedQty: "Kuantiti Dipesan",
        Totalqty: "Jumlah kuantiti",
        StockingOut: "Keluar stok...",
        StockingIn: "Masuk stok...",
        thiorderUpdateStuau: "pesanan ini? Tindakan ini akan mengemas kini statusnya.",
        TransactionDetails: "Butiran Transaksi",
        Fetchingtransactiondetails: "Mengambil butiran transaksi...",
        Nodetailsfoundforthistransaction: "Tiada butiran untuk transaksi ini.",
        TotalBreakDown: "Pecahan Jumlah",
        ChangeAmount: "Amaun Tukar",
        Attachments: "Lampiran",
        PoNumber: "Nombor PO",
        SoNumber: "Nombor SO",
        partner: "Rakan kongsi",
        EditPurchase: "Sunting Pembelian",
        EditSales: "Sunting Jualan",
        PurchaseOrderDetails: "Butiran Pesanan Pembelian",
        SalesOrderDetails: "Butiran Pesanan Jualan",
        OrderType: "Jenis Pesanan",
        SelectOrderType: "Pilih Jenis Pesanan",
        OrderTypePrepaid: "Prabayar",
        OrderTypeCOD: "Bayar semasa Penghantaran",
        OrderTypePayLater: "Bayar Kemudian",
        OrderTypePartialPayment: "Bayaran Separa",
        OrderTypeSubscription: "Langganan",
        viewAvailabilty: 'Lihat Ketersediaan',
        NotReceived: "Belum Diterima",
        NotShipped: "Belum Dihantar",
        PartiallyReceived: "Diterima Sebahagian",
        PartiallyShipped: "Dihantar Sebahagian",
    },
    PriceReference: {
        HighPrice: "Harga Tinggi",
        LowPrice: "Harga Rendah",
        LastPrice: "Harga Terakhir",
        LastPurchasePrice: "Harga Belian Terakhir",
        Nopricerecordsfound: "Tiada rekod harga ditemui",
        BuyingPriceReference: "Rujukan Harga Beli",
        SellingPriceReference: "Rujukan Harga Jual",
        Viewstockinpricesfortheselectedvendorandproduct: "Lihat harga masuk stok untuk vendor dan produk terpilih",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Lihat harga keluar stok untuk pelanggan dan produk terpilih"
    },
    SubscriptionLocale: {
        premiumPlan: "Pelan Premium",
        heading: "Buat Keputusan Perniagaan",
        headingHighlight: "Berdasarkan Data",
        subtitle: "Buka kuasa penuh analitik perniagaan anda — tiada had, tiada kompromi.",
        choosePlan: "Pilih pelan anda",
        monthly: "Bulanan",
        annual: "Tahunan",
        oneTime: "Sekali Saja (Bulanan)",
        perMonth: "sebulan",
        perYear: "setahun",
        bestValue: "Nilai Terbaik",
        continueWith: "Teruskan dengan",
        perMonthShort: "bln",
        perYearShort: "thn",
        troubleWithSubscription: "Masalah dengan langganan?",
        contactUs: "Hubungi Kami",
        paymentNotReady: "Bayaran belum sedia",
        checkoutError: "RALAT CHECKOUT",
        pricePreviewError: "RALAT PRATINJAU HARGA",
        subNotAvailable: "Langganan tidak tersedia",
        subNotAvailableDesc: "Langganan web kini tidak tersedia di negara anda. Sila langgan melalui aplikasi mudah alih kami atau hubungi kami untuk bantuan."
    },
    SubscriptionLocale2: {
        GoPro: "Beralih ke Pro",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Buat keputusan yang lebih pintar disokong oleh data perniagaan sebenar",
        ExploreProPlans: "Terokai Pelan Pro"
    },
    emptyWarehouseState: {
        tips: [
            "Anda boleh mempunyai beberapa gudang untuk lokasi fizikal yang berbeza",
            "Setiap produk menjejak stok per gudang secara bebas",
            'Gunakan "Pindah Gudang" untuk memindahkan stok antara lokasi'
        ],
        NoWarehousesConfigured: "Tiada Gudang Dikonfigurasi",
        desc: "Mulakan dengan menambah gudang anda (jika anda mempunyai lebih daripada satu), kemudian teruskan untuk menambah produk dan merekod pergerakan stok.",
        WarehouseSetupTips: "Tips Persediaan Gudang",
        Noproductselected: "Tiada produk dipilih",
        Selectaproductfromthelefttoviewlowstockdetails: "Pilih produk dari sebelah kiri untuk melihat butiran stok rendah.",
        Chooseaproductfromthelist: "Pilih produk dari senarai",
        SelectProduct: "Pilih Produk",
        SetQuantity: "Tetapkan Kuantiti",
        Showing: "Menunjukkan",
        products: "produk",
        Continue: "Teruskan",
        SaveSafetyStock: "Simpan Stok Keselamatan",
        SafetyStockSaved: "Stok Keselamatan Disimpan!",
        hasbeensetto: "telah ditetapkan kepada",
        AddAnother: "Tambah Lagi",
        Chooseaproduct: "Pilih produk",
        Step: "Langkah",
        of: "daripada",
        Setsafetyquantity: "Tetapkan kuantiti keselamatan",
        Complete: "Selesai",
        SafetyStockQuantity: "Kuantiti Stok Keselamatan",
        Minimumunitsdropsbelowthisnumber: "Unit minimum yang sentiasa disimpan dalam stok. Amaran akan dicetuskan apabila stok jatuh di bawah nombor ini.",
        NewSafetyStock: "Stok Keselamatan Baharu",
        SafetyNow: "Keselamatan Sekarang",
        SettingTo: "Menetapkan kepada",
        Change: "Tukar",
        sell: "jual",
        cost: "kos",
        BulUD: "Muat Naik/Padam Pukal"
    },
    SimplyLoginUI: {
        sslEncryption: "Enkripsi SSL 256-bit",
        dataPrivate: "Data anda 100% peribadi",
        worksOnDevices: "Berfungsi pada Android & iPhone",
        realTimeSync: "Penyelarasan masa nyata merentas semua peranti",
        cloudBackup: "Sandaran awan automatik",
        availableOn: "Tersedia di Web, Android & iOS",
        tagline: "Inventori anda,",
        taglineEm: "sangat mudah dan cantik.",
        subtitle: "Log masuk untuk mengurus stok, menjejak jualan, dan menjalankan perniagaan anda — semuanya di satu tempat.",
        feature1Title: "Penjejakan stok masa nyata",
        feature1Desc: "Tahu dengan tepat apa yang ada di setiap gudang, sentiasa terkini.",
        feature2Title: "Pesanan jualan & pembelian",
        feature2Desc: "Cipta invois, urus vendor, dan jejak setiap transaksi.",
        feature3Title: "Laporan pintar",
        feature3Desc: "Laporan kewangan, stok dan pergerakan harian dalam sekelip mata.",
        feature4Title: "Penyelarasan masa nyata merentas semua peranti",
        feature4Desc: "Perubahan di telefon muncul serta-merta di web — dan sebaliknya.",
        rating1: "Dinilai",
        rating2: "4.9/5",
        rating3: "oleh 10,000 perniagaan borong",
        brandName: "Simply",
        greeting: "Hello lagi! 👋",
        noPasswordNeeded: "Log masuk untuk mengakses inventori anda — Android, iPhone & web, semuanya selaras.",
        badge1: "Pengurusan Stok",
        badge2: "Penjejakan Jualan",
        badge3: "Laporan",
        trustEncryptedTitle: "Terenkripsi",
        trustEncryptedSub: "SSL 256-bit",
        trustPrivateTitle: "Peribadi",
        trustPrivateSub: "Data anda sahaja",
        trustBackedTitle: "Disandarkan",
        trustBackedSub: "Auto harian",
        availableOnLabel: "TERSEDIA DI",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Semua peranti selaras serta-merta secara masa nyata",
        securityNote: "100% selamat.",
        securityDesc: "Enkripsi tahap bank melindungi semua data anda. Kami hanya membaca nama dan emel anda — tiada apa-apa lagi, selamanya.",
        signingIn: "Sedang log masuk…",
        termsPrefix: "Dengan log masuk anda bersetuju dengan",
        privacyPolicy: "Dasar Privasi",
        and: "dan",
        termsOfService: "Syarat Perkhidmatan",
        google: "Log masuk dengan Google"
    },
    BatchLocal: {
        BatchName: "Nama Batch",
        EnterBatchName: "Masukkan nama batch",
        EnterNotes: "Masukkan nota",
        ExpiredDate: "Tarikh Luput",
        Selectexpireddate: "Pilih tarikh luput",
        BatchStatus: "Status Batch",
        CreatedDate: "Tarikh Dicipta",
        Areyousureyouwanttodeletethisbatch: "Adakah anda pasti mahu memadam batch ini?",
        Youhavencreatedanybatchforthisproduct: "Anda belum mencipta sebarang batch untuk produk ini.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Cipta batch pertama anda untuk mula menjejak stok mengikut lot & tarikh luput.",
        Nobatchesyet: "Belum ada batch",
        Whatisbatchmanagement: "Apakah itu pengurusan batch?",
        Howithelpsyourbusiness: "Bagaimana ia membantu perniagaan anda",
        Trackbylotnumber: "Jejak mengikut nombor lot",
        Trackbylotnumberdesc: "Kumpulkan stok mengikut batch pengeluar supaya anda sentiasa tahu unit berasal dari lot mana.",
        Expirydatecontrol: "Kawalan tarikh luput",
        Expirydatecontroldesc: "Dapatkan amaran sebelum stok luput. Jual batch lama dahulu dan kurangkan pembaziran secara automatik.",
        Fulltraceability: "Penjejakan penuh",
        Fulltraceabilitydesc: "Lihat dengan tepat batch mana yang digunakan dalam setiap transaksi — bagus untuk audit dan penarikan balik.",
        Supplierwisestock: "Stok mengikut pembekal",
        Supplierwisestockdesc: "Pisahkan stok daripada pembekal berbeza walaupun untuk produk yang sama. Bandingkan kualiti batch demi batch.",
        Createyourfirstbatchbutton: "Cipta batch pertama anda",
        Nomatchesfound: "Tiada padanan ditemui",
        NomatchesfounddescBefore: "Kami tidak dapat mencari sebarang batch yang sepadan dengan ",
        NomatchesfounddescAfter: "",
        Clearsearch: "Kosongkan carian",
        Nohistoryfoundthisbatch: "Tiada sejarah ditemui untuk batch ini",
        ComprehensiveDetails: "Butiran Komprehensif",
        History: "Sejarah",
        InBatch: "Dalam Batch",
        Noproductfoundinthisbatch: "Tiada produk ditemui dalam batch ini",
        SelectBatch: "Pilih Batch",
        available: "tersedia",
        Searchbatches: "Cari batch...",
        Expires: "Luput",
        Nobatchesfound: "Tiada batch ditemui",
        ManageBatches: "Urus Batch",
        Batchmanagement: "Pengurusan Batch",
        Trackstockexpiry: "Jejak stok mengikut batch & luput",
        Turnoffbatchmanagement: "Matikan pengurusan batch?",
        Yourgsafe: "Data batch sedia ada anda kekal selamat.",
        Reenableanytimefrom: "Anda boleh mengaktifkannya semula pada bila-bila masa dari",
        Otherstab: "tab Lain-lain",
        AddBatch: "Tambah Batch",
        Total: "Jumlah",
        AssignProduct: "Tetapkan Produk",
        EditProductAssignment: "Edit Penetapan Produk",
        AssignProducttoBatch: "Tetapkan produk ke batch",
        Updateproductconfiguration: "Kemas kini konfigurasi produk",
        Step1of2: "Langkah 1 daripada 2",
        Step2of2: "Langkah 2 daripada 2",
        Selectvariantwarehouse: "Pilih varian & gudang",
        SelectedProduct: "Produk Terpilih",
        AssignQuantity: "Tetapkan Kuantiti",
        BatchInfo: "Maklumat Batch",
        Wecouldnthisproductidentifier: "Kami tidak dapat mencari sebarang batch yang dikaitkan dengan pengecam produk ini.",
        NoActiveBatches: "Tiada Batch Aktif",
        Endofresults: "Akhir hasil",
        Expiry: "Luput",
        BatchManagementDescription: "Jejaki stok mengikut nombor kelompok dan tarikh luput. Memastikan turutan LIFO / FEFO yang betul pada setiap stok keluar — tidak perlu pemilihan manual.",
        Expiryalerts: "Amaran tarikh luput",
        Autonotifications: "Notifikasi automatik",
        LIFOsorting: "Isihan LIFO / FEFO",
        Smartstockflow: "Aliran stok pintar",
        Perout: "Stok keluar setiap kelompok",
        Precisiontracking: "Penjejakan tepat",
        NeedsReview: "Perlu semakan",
        Pending: "Menunggu",
        Rejected: "Ditolak",
        Approved: "Diluluskan",
        WaitingForApproval: "Menunggu kelulusan",
        WaitingForApprovalDesc: "Pemilik anda akan menyemak dan meluluskan batch ini tidak lama lagi.",
        BatchRejected: "Batch ditolak",
        BatchRejectedDesc: "Pemilik anda telah menolak batch ini.",
        Reason: "Sebab",
        Approve: "Luluskan",
        Reject: "Tolak",
        ConfirmApproveTitle: "Luluskan batch",
        ConfirmRejectTitle: "Tolak batch",
        ConfirmApprovalAction: "Adakah anda pasti mahu {action} batch ini? Tindakan ini akan mengemas kini statusnya.",
        ReasonOptional: "Sebab (Pilihan)",
        EnterReasonPlaceholder: "Masukkan sebab untuk {action} (pilihan)",
        Processing: "Memproses...",
        BatchActivatedSuccess: "Batch berjaya diaktifkan",
        BatchDeactivatedSuccess: "Batch berjaya dinyahaktifkan",
        BatchDeletedSuccess: "Batch berjaya dipadam",
        BatchApprovedSuccess: "Batch berjaya diluluskan",
        BatchRejectedSuccess: "Batch berjaya ditolak",
        SearchByBatchName: "Cari mengikut nama batch...",
        YesTurnOff: "Ya, matikan",
        KeepItOn: "Biarkan hidup"
    },
    CategoryNewL: {
        TotalCategories: "Jumlah Kategori",
        lastaddedcategory: "Kategori terakhir ditambah",
        acrossalltypes: "merentasi semua jenis",
        MostRecent: "Paling terkini",
        YesD: "Ya, Padam",
        AllAssociated: "Semua produk berkaitan mungkin akan terjejas"
    },
    OverDas: {
        movestockbetweenlocations: "Pindah stok antara lokasi",
        no_activity_yet: "Belum ada aktiviti",
        no_activity_sub: "Jualan, pembelian, pergerakan stok dan pulangan akan muncul di sini secara masa nyata.",
        make_first_sale: "Buat Jualan Pertama",
        add_stock: "Tambah Stok",
        all_stock_healthy: "Semua tahap stok sihat",
        all_stock_healthy_sub: "Tiada item yang hampir habis. Tetapkan ambang minimum pada produk untuk mendapatkan amaran di sini.",
        set_stock_thresholds: "Tetapkan Ambang Stok",
        no_warehouses_setup: "Tiada gudang disediakan",
        no_warehouses_setup_sub: "Tambah gudang untuk mula menjejak di mana stok anda disimpan dan mengurus lokasi.",
        add_first_warehouse: "Tambah Gudang Pertama",
        Customer: "Pelanggan",
        PurchasevsSales: "Pembelian vs Jualan",
        Financialperformancechart: "Carta prestasi kewangan",
        QuickActions: "Tindakan Pantas",
        Frequentlyused: "Kerap digunakan",
        Addinventory: "Tambah inventori",
        Dispatchitems: "Hantar barang",
        Addorder: "Tambah pesanan",
        Newitem: "Barang baru",
        Inventoryaccess: "Akses inventori",
        Itemsneedingreorder: "Barang yang perlu dipesan semula",
        Latesttransactions: "Transaksi terkini",
        Operationalsummary: "Ringkasan operasi",
        ViewAll: "Lihat Semua",
        Manage: "Urus",
        RecentActivity: "Aktiviti Terkini",
        LowStockAlerts: "Amaran Stok Rendah",
        Primary: "Utama",
        TotalWarehouses: "Jumlah Gudang"
    },
    SerialLocal: {
        ShowOrHideFields: "Tunjukkan atau sembunyikan medan",
        ShowOrHideFieldsDesc: "Ketik mana-mana item di bawah untuk memasukkan atau mengeluarkannya daripada invois yang dicetak. Perubahan digunakan serta-merta.",
        Manufacturesettings: "Tetapan pembuatan",
        Showbuyingprice: "harga beli / kos produk",
        Showadditionalcost: "kos tambahan",
        Costbreakdown: "Pecahan kos",
        Unitcost: "Kos seunit",
        Rawmaterialstotal: "Jumlah bahan mentah",
        Confirmentry: "Sahkan entri",
        SaveSerials: "Simpan Nombor Siri",
        SerialNumber: "Nombor Siri",
        selected: "dipilih",
        added: "ditambah",
        Serialnumbers: "Nombor siri",
        ResetAll: "Tetapkan Semula Semua",
        Wecouldnfindthis: "Kami tidak dapat mencari sebarang nombor siri yang tersedia untuk produk ini.",
        Nounitsfound: "Tiada unit ditemui",
        Searchingserialnumbers: "Mencari nombor siri...",
        Scanorenterstock: "Imbas atau masukkan nombor siri untuk stok baharu",
        Whataserialnumber: "Apakah nombor siri?",
        Auniqueidentifieryourinventorylifecycle: "Pengecam unik bagi setiap unit — membolehkan anda mengesan setiap item secara individu sepanjang kitaran hayat inventori anda.",
        Trackedstockout: "Stok keluar yang dijejaki",
        Chooseexactlyselected: "Pilih dengan tepat nombor siri mana yang keluar. Hanya siri yang telah distok untuk produk ini ditunjukkan — kuantiti akan dikunci setelah anda memilih ",
        SelectSerialstoout: " - Pilih Nombor Siri untuk Keluar",
        Thisinvoicegeneratedusingwwwsimplstockco: "Invois ini dijana menggunakan www.simplstock.co",
        AuthorizedSignature: "Tandatangan yang Dibenarkan",
        Invoicesettings: "Tetapan Invois",
        Draw: "Lukis",
        Taptoselectordeselectitems: "Ketuk untuk memilih atau membatalkan pilihan item",
        Thissignaturewillbeadded: "Tandatangan ini akan ditambah di bahagian bawah invois cetakan anda.",
        SignatureOptions: "Pilihan Tandatangan",
        Upload: "Muat Naik",
        DrawSignature: "Lukis Tandatangan",
        UploadSignature: "Muat Naik Tandatangan",
        Clear: "Kosongkan",
        ShowStaffName: "Nama Kakitangan",
        ShowSKU: "SKU",
        ShowBusinessName: "Nama Perniagaan",
        ShowProductName: "Nama Produk",
        ShowBusinessPhoneNumber: "Nombor Telefon",
        ShowBusinessEmail: "Emel",
        ShowBusinessAddress: "Alamat",
        ShowProductImage: "Imej Produk",
        ShowPaymentDetails: "Butiran Pembayaran",
        ShowCategory: "Kategori",
        ShowVariant: "Varian",
        ShowWarehouse: "Gudang",
        ShowAttributes: "Atribut",
        ShowQuantity: "Kuantiti",
        ShowDiscount: "Diskaun",
        ShowTax: "Cukai",
        ShowPrice: "Harga",
        ShowTotalPrice: "Jumlah Harga Produk",
        ShowExpenses: "Perbelanjaan",
        ShowSignature: "Tandatangan",
        ShowNote: "Nota",
        ShowSerialNumber: "Nombor Siri",
        Invoicesettingsapplied: "Tetapan invois telah diterapkan. Semak invois untuk perubahan.",
        EnterSerialNumber: "Masukkan Nombor Siri",
        showAttachment: "Lampiran"
    },
    FewLocal: {
        SelectBin: "Pilih Bin",
        Live: "Live",
        Monitorinventorystocklevels: "Pantau inventori, pergerakan & tahap stok",
        StockControlCentre: "Pusat Kawalan Stok",
        Nochartdataavailable: "Tiada data carta tersedia",
        Disabled: "Dilumpuhkan",
        Enabled: "Diaktifkan"
    },
    Bin: {
        Bin: "Bin",
        Add: "Tambah",
        NoBinsAddedYet: "Belum ada bin ditambah",
        BinLocationsHelp: "Lokasi bin membantu anda menjejak stok mengikut kedudukan tepat di dalam gudang ini — tiada lagi pencarian.",
        NameThemByPosition: "Namakan mengikut kedudukan:",
        AddBinLocation: "Tambah Lokasi Bin",
        BinLocations: "lokasi bin",
        BinNameRequired: "Nama bin diperlukan",
        EditBin: "Edit Bin",
        AddBin: "Tambah Bin",
        EnterBinName: "Nama Bin",
        EnterBinNamePlaceholder: "Masukkan nama bin",
        BinStatus: "Status Bin",
        BinNotes: "Nota",
        EnterBinNotesPlaceholder: "Tambah nota...",
        ViewInventory: "Lihat Inventori",
        Inventory: "Inventori",
        TrymatchingadifferentSKUname: "Cuba padankan SKU atau nama lain.",
        Thisbinlocationcurrentlyempty: "Lokasi bin ini kini kosong.",
        Loadingbins: "Memuatkan bin...",
        bins: "bin",
        ManageBin: "Urus Bin",
        Print: "Cetak",
        SBin: "Bin Sumber",
        DBin: "Bin Destinasi"
    },
    WarehouseExcel: {
        title: "Muat Naik Gudang & Lokasi Bin",
        description: "Ikuti langkah-langkah di bawah untuk mencipta gudang secara pukal bersama lokasi bin menggunakan fail Excel.",
        bulkUploadGuide: "Panduan Muat Naik Pukal",
        step1: "Langkah 1",
        downloadTemplate: "Muat turun template Excel",
        downloadTemplateDesc: "Dapatkan template rasmi dengan semua pengepala lajur yang diperlukan. Jangan tukar nama atau padamkan mana-mana lajur.",
        downloadTemplateBtn: "Muat Turun Template",
        step2: "Langkah 2",
        fillExcelFile: "Isi fail Excel",
        fillExcelDesc: "Setiap baris mewakili satu gudang. Isi semua lajur — untuk lokasi bin, masukkan semua nama bin dipisahkan koma dalam lajur <code>Bin Names</code>.",
        step3: "Langkah 3",
        thingsToKeepInMind: "Perkara yang perlu diingat",
        rulesDesc: "Sebelum memuat naik, pastikan fail anda mematuhi peraturan ini.",
        step4: "Langkah 4",
        uploadYourFile: "Muat naik fail anda",
        uploadDesc: "Setelah diisi, muat naik fail di bawah. Sistem akan mencipta semua gudang dan lokasi bin secara automatik.",
        rules: ["Satu baris bagi setiap gudang", "Nama bin dipisahkan koma dalam satu sel", "Jangan tukar nama pengepala lajur", "Nama bin pendua bagi gudang yang sama akan dilangkau", "Nombor telefon dengan kod negara", "Hanya fail .xlsx atau .xls diterima"],
        dropFileHere: "Letakkan fail Excel anda di sini",
        supports: "Menyokong .xlsx dan .xls — maksimum 10 MB",
        chooseFileUpload: "Pilih Fail & Muat Naik",
        parsing: "Mengurai fail...",
        invalidFileType: "Jenis fail tidak sah. Sila muat naik fail Excel.",
        noData: "Tiada data dijumpai dalam Excel",
        failedToRead: "Gagal membaca fail Excel",
        unableToRead: "Tidak dapat membaca fail.",
        reviewTitle: "Semak Data Gudang",
        reviewSubtitle: "Semakan akhir sebelum import ke perniagaan anda.",
        changeFile: "Tukar Fail",
        rowsFound: "baris ditemui",
        cancel: "Batal",
        finalizeImport: "Selesaikan & Import",
        importing: "Mengimport...",
        success: "Berjaya",
        allWarehouseUploadedSuccess: "Semua gudang berjaya dimuat naik",
        failed: "Gagal",
        bulkUploadFailed: "Muat naik pukal gagal",
        error: "Ralat",
        binNamesNote: "Dalam lajur <strong>Bin Names</strong>, masukkan semua lokasi bin untuk gudang dalam satu sel, dipisahkan koma — contoh: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Nama Gudang", email: "Emel", phoneNumber: "Nombor Telefon", location: "Lokasi", binNames: "Nama Bin" }
    },
    CustomerExcel: {
        title: "Muat Naik Pelanggan",
        description: "Ikuti langkah di bawah untuk membuat pelanggan secara pukal menggunakan fail Excel.",
        bulkUploadGuide: "Panduan Muat Naik Pukal",
        step1: "Langkah 1",
        downloadTemplate: "Muat turun templat Excel",
        downloadTemplateDesc: "Dapatkan templat rasmi dengan semua pengepala lajur yang diperlukan yang telah dikonfigurasikan.",
        downloadTemplateBtn: "Muat Turun Templat",
        step2: "Langkah 2",
        fillExcelFile: "Isi fail Excel",
        fillExcelDesc: "Setiap baris mewakili satu pelanggan. Isi semua lajur seperti yang diperlukan.",
        step3: "Langkah 3",
        thingsToKeepInMind: "Perkara untuk diingat",
        rulesDesc: "Sebelum memuat naik, pastikan fail anda mengikut peraturan ini untuk mengelakkan ralat.",
        step4: "Langkah 4",
        uploadYourFile: "Muat naik fail anda",
        uploadDesc: "Setelah diisi, muat naik fail di bawah. Sistem akan mencipta semua pelanggan secara automatik.",
        rules: [
            "Satu baris bagi setiap pelanggan sahaja",
            "Jangan tukar nama pengepala lajur",
            "Nombor telefon dengan kod negara",
            "Hanya fail .xlsx atau .xls diterima"
        ],
        dropFileHere: "Letakkan fail Excel anda di sini",
        supports: "Menyokong .xlsx dan .xls — maks 10 MB",
        chooseFileUpload: "Pilih Fail & Muat Naik",
        parsing: "Mengurai fail...",
        invalidFileType: "Jenis fail tidak sah. Sila muat naik fail Excel.",
        noData: "Tiada data ditemui dalam Excel",
        failedToRead: "Gagal membaca fail Excel",
        unableToRead: "Tidak dapat membaca fail.",
        reviewTitle: "Semak Data Pelanggan",
        reviewSubtitle: "Semakan akhir sebelum mengimport ke dalam perniagaan anda.",
        changeFile: "Tukar Fail",
        rowsFound: "baris ditemui dalam fail",
        cancel: "Batal",
        finalizeImport: "Selesaikan & Import",
        importing: "Mengimport...",
        success: "Berjaya",
        allCustomerUploadedSuccess: "Semua pelanggan berjaya dimuat naik",
        failed: "Gagal",
        bulkUploadFailed: "Muat naik pukal gagal",
        error: "Ralat",
        headers: {
            customerName: "Nama Pelanggan",
            phoneNumber: "Kenalan",
            address: "Alamat",
            note: "Nota"
        }
    },
    SupplierExcel: {
        title: "Muat Naik Vendor",
        description: "Ikuti langkah di bawah untuk membuat vendor secara pukal menggunakan fail Excel.",
        bulkUploadGuide: "Panduan Muat Naik Pukal",
        step1: "Langkah 1",
        downloadTemplate: "Muat turun templat Excel",
        downloadTemplateDesc: "Dapatkan templat rasmi dengan semua pengepala lajur yang diperlukan yang telah dikonfigurasikan.",
        downloadTemplateBtn: "Muat Turun Templat",
        step2: "Langkah 2",
        fillExcelFile: "Isi fail Excel",
        fillExcelDesc: "Setiap baris mewakili satu vendor. Isi semua lajur seperti yang diperlukan.",
        step3: "Langkah 3",
        thingsToKeepInMind: "Perkara untuk diingat",
        rulesDesc: "Sebelum memuat naik, pastikan fail anda mengikut peraturan ini untuk mengelakkan ralat.",
        step4: "Langkah 4",
        uploadYourFile: "Muat naik fail anda",
        uploadDesc: "Setelah diisi, muat naik fail di bawah. Sistem akan mencipta semua vendor secara automatik.",
        rules: [
            "Satu baris bagi setiap vendor sahaja",
            "Jangan tukar nama pengepala lajur",
            "Nombor telefon dengan kod negara",
            "Hanya fail .xlsx atau .xls diterima"
        ],
        dropFileHere: "Letakkan fail Excel anda di sini",
        supports: "Menyokong .xlsx dan .xls — maks 10 MB",
        chooseFileUpload: "Pilih Fail & Muat Naik",
        parsing: "Mengurai fail...",
        invalidFileType: "Jenis fail tidak sah. Sila muat naik fail Excel.",
        noData: "Tiada data ditemui dalam Excel",
        failedToRead: "Gagal membaca fail Excel",
        unableToRead: "Tidak dapat membaca fail.",
        reviewTitle: "Semak Data Vendor",
        reviewSubtitle: "Semakan akhir sebelum mengimport ke dalam perniagaan anda.",
        changeFile: "Tukar Fail",
        rowsFound: "baris ditemui dalam fail",
        cancel: "Batal",
        finalizeImport: "Selesaikan & Import",
        importing: "Mengimport...",
        success: "Berjaya",
        allSupplierUploadedSuccess: "Semua vendor berjaya dimuat naik",
        failed: "Gagal",
        bulkUploadFailed: "Muat naik pukal gagal",
        error: "Ralat",
        headers: {
            supplierName: "Nama Vendor",
            phoneNumber: "Kenalan",
            bankName: "Nama Bank",
            accountHolderName: "Nama Pemegang Akaun",
            accountNumber: "Nombor Akaun",
            note: "Nota"
        }
    },
    VariantTemplate: {
        VariantTemplates: "Templat Variasi",
        Managereusablevariantpatterns: "Urus corak variasi yang boleh diguna semula",
        BinTransferHistory: "Sejarah Pemindahan Bin",
        Trackmovementsacrossbins: "Jejaki pergerakan antara bin",
        SerialNumberHistory: "Sejarah Nombor Siri",
        Trackproductserialnumberactivity: "Jejaki aktiviti nombor siri produk",
        Period: "Tempoh",
        Nohistoryfound: "Tiada sejarah ditemui",
        Searchserialnumbers: "Cari nombor siri...",
        SerialNumbersHistory: "Sejarah Nombor Siri",
        Serialnumberhistoryglance: "Sejarah nombor siri sekilas pandang.",
        Noserialnumbersfound: "Tiada nombor siri ditemui",
        Noactivityhistoryfound: "Tiada sejarah aktiviti ditemui",
        Statussetto: "Status ditetapkan kepada",
        Timeline: "Garis masa",
        Managereusableproductvariantpatterns: "Urus corak variasi produk yang boleh diguna semula.",
        DeleteTemplate: "Padam Templat",
        Areyousureyouwanttemplate: "Adakah anda pasti mahu memadam templat ini?",
        CreateNewTemplate: "Cipta Templat Baharu",
        CreateTemplate: "Cipta Templat",
        EditTemplate: "Edit Templat",
        UnlimitedTemplates: "Templat tanpa had",
        CreateAsManyTemplates: "Cipta seberapa banyak templat yang anda perlukan — Pakaian, Kasut, Elektronik dan lain-lain.",
        PickWhileAddingProduct: "Pilih semasa menambah produk",
        OpenTemplateLibrary: "Buka pustaka templat anda dan pilih nama variasi dalam beberapa saat.",
        MixFromMultipleTemplates: "Gabung dari templat berbilang",
        SelectFromMultipleTemplates: "Pilih nama variasi dari lebih daripada satu templat untuk satu produk — sepenuhnya fleksibel.",
        EditAnytime: "Edit bila-bila masa",
        RenameTemplatesAnytime: "Tukar nama templat, tambah atau buang nama variasi bila-bila masa katalog anda berubah.",
        StayConsistent: "Kekal konsisten",
        SameVariantNamesAcrossAll: "Nama variasi yang sama di semua produk. Tiada kesilapan taip, tiada pendua, tiada tekaan.",
        BuildOnceUseEverywhere: "Cipta sekali, guna di mana-mana",
        StopReEnteringVariantNames: "Berhenti menaip semula nama variasi yang sama untuk setiap produk. Cipta templat, tetapkan nama variasi, dan gunakan semula serta-merta.",
        Updateexistingvariantcombinations: "Kemas kini kombinasi variasi sedia ada",
        Definenewvariantcombinations: "Takrifkan kombinasi variasi baharu",
        TemplateName: "Nama Templat",
        AddVariantOptions: "Tambah Pilihan Variasi",
        SmallMedium: "cth. Kecil, Sederhana...",
        VariantsList: "Senarai Variasi",
        Nooptionsaddedyet: "Belum ada pilihan ditambah",
        SaveTemplate: "Simpan Templat",
        egSizesColorsetc: "cth. Saiz T-Shirt, Warna, dll.",
        Pleaseentertemplatename: "Sila masukkan nama templat",
        Pleaseaddatleastonevariantoption: "Sila tambah sekurang-kurangnya satu pilihan variasi",
        Templateupdatedsuccessfully: "Templat berjaya dikemas kini",
        Templatecreatedsuccessfully: "Templat berjaya dicipta",
        Failedtosavetemplate: "Gagal menyimpan templat",
        Transfer: "Pindah",
        Editassignment: "Edit tugasan",
        Updateproductdetailsinbin: "Kemas kini butiran produk dalam bin",
        Editinginbin: "Mengedit dalam bin",
        ConfirmUpdate: "Sahkan Kemas Kini",
        ConfirmAssign: "Sahkan Tugasan",
        Assignanotherproduct: "Tugaskan produk lain",
        TransferBin: "Pindah Bin",
        SourceBin: "Bin Sumber",
        DestinationBin: "Bin Destinasi",
        SelectSourceBin: "Pilih Bin Sumber",
        SelectDestinationBin: "Pilih Bin Destinasi",
        Unit: "Unit",
        ManageVariant: "Urus Variasi",
        CreateSKUvariationsyourproduct: "Cipta variasi SKU untuk produk anda",
        Assigningvariationsto: "Menugaskan variasi kepada",
        Novariantsaddedyet: "Belum ada variasi ditambah",
        AddedVariants: "Variansi Ditambah",
        AddVariantsfromTemplate: "Tambah Variasi dari Templat",
        Pickatemplateandselectvariantnames: "Pilih templat dan pilih nama variasi",
        ChooseaTemplate: "Pilih Templat",
        Selectvariantnamestoadd: "Pilih nama variasi untuk ditambah",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Pilih templat untuk memilih nama variasi. Anda boleh tambah dari berbilang templat.",
        Loadingtemplates: "Memuatkan templat...",
        Backtotemplates: "Kembali ke templat",
        Selectallindividualadd: "Pilih semua atau nama variasi individu untuk ditambah.",
        VariantNames: "Nama Variasi",
        MediaDescription: "Media & Penerangan",
        Addattachmentsandproductnotes: "Tambah lampiran dan nota produk",
        ProductMedia: "Media Produk"
    },
    AddProductGuide: {
        title: "Tambah kuantiti awal selepas simpan",
        description: "Produk tidak mempunyai medan kuantiti di sini. Selepas disimpan, gunakan 'Stock In' untuk log stok pembukaan anda — dengan kawalan penuh ke atas lokasi dan penjejakan.",
        steps: {
            quantity: { title: "Kuantiti", sub: "Tetapkan kiraan stok pembukaan" },
            binLocation: { title: "Lokasi Bin", sub: "Lorong, rak, rak — contoh: A-01-03" },
            serialNumbers: { title: "Nombor Siri", sub: "Jejaki setiap unit secara individu" },
            warehouse: { title: "Gudang", sub: "Lokasi mana ia disimpan" },
            batchExpiry: { title: "Batch / Tamat Tempoh", sub: "Kumpulkan stok mengikut nombor batch" }
        },
        actions: { close: "Tutup" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Tiada Perintah Pemindahan Ditemui",
        Itemshistory: "Barang yang anda pindahkan antara gudang akan muncul di sini untuk penjejakan och sejarah.",
        CreateTransfer: "Buat Pemindahan"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Ketuk pada produk untuk Mengilang",
        Selectproductfrombelow: "Pilih produk daripada senarai di bawah",
        SetupANewProduct: "Sediakan Produk Baharu",
        DefineAProductAdditsrawmaterial: "Takrifkan Produk & Tambah bahan mentahnya",
        ManufacturingSetup: "Persediaan Pengilangan",
        Pickproducttodefineitsproductiondetails: "Pilih produk untuk menentukan butiran pengeluarannya",
        ConfigureManufacturing: "Konfigurasi Pengilangan",
        SelectRawMaterial: "Pilih Bahan Mentah",
        NoRawMaterials: "Tiada Bahan Mentah",
        Definecomponentsneededtoproduct: "Tentukan komponen yang diperlukan untuk mengilang produk ini.",
        NoAdditionalCosts: "Tiada Kos Tambahan",
        Addlaboroverheadlogisticalcharges: "Tambah kos buruh, overhed atau caj logistik.",
        AddAdditionalCost: "Tambah Kos Tambahan",
        AddCost: "Tambah Kos",
        TotalPrice: "Jumlah Harga",
        SelectCharges: "Pilih Caj",
        EnterEstimatedCost: "Masukkan Kos Anggaran",
        QtyRequried: "Kuantiti Diperlukan",
        Manufacturing: "Pengilangan",
        Outputfinishedgoodsdestination: "Destinasi barangan siap",
        Manufacturingquantity: "Kuantiti pengilangan",
        Storefinishedgoodsat: "Simpan barangan siap di",
        Rawmaterials: "Bahan mentah",
        StockSelection: "Pemilihan Stok",
        AdditionalCosts: "Kos Tambahan",
        Quantityconsume: "Kuantiti digunakan",
        Totalmanufacturingcost: "Jumlah kos pengilangan",
        Sumofrawmaterialcosts: "Jumlah semua kos bahan mentah",
        CustomManufacturingCharge: "Caj Pengilangan Khas",
        Addextralikelaboroverheadrepairs: "Tambah kos tambahan seperti buruh, overhed atau pembaikan.",
        CalculatedTotal: "Jumlah Kiraan",
        AddRawMaterial: "Tambah Bahan Mentah",
        ConfigureRawMaterial: "Konfigurasi Bahan Mentah",
        Thisoutputunit: "Ini adalah kuantiti asas yang diperlukan bagi setiap unit output.",
        ChangeProduct: "Tukar Produk",
        AddtoList: "Tambah ke Senarai",
        ManufacturedSuccessfully: "Berjaya Dikilang",
        Manufacture: "Pembuatan",
        EditDeleteHistory: "Sejarah Sunting/Padam",
        ManageOrder: "Urus Pesanan",
        ManageBatch: "Urus Batch",
        Paymentnotavailablehere: "Pembayaran tidak tersedia di sini",
        Thisrecordisanorderorderitself: "Rekod ini adalah daripada pesanan. Pembayaran hanya boleh direkodkan daripada pesanan itu sendiri.",
        Torecorpaymenttheorderthethere: "Untuk merekod pembayaran, pergi ke pesanan yang dipautkan dan gunakan pilihan <b>Rekod Pembayaran</b> di sana.",
        GotoOrder: "Pergi ke Pesanan"
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Diganti Dengan",
        Noreplacementhistoryfound: "Tiada sejarah penggantian ditemui",
        Noreturnhistoryfound: "Tiada sejarah pemulangan ditemui",
        Productbeingreturned: "Produk yang dipulangkan",
        Required: "Wajib",
        Selectreturnedproduct: "Pilih produk yang dipulangkan",
        Searchnamescanbarcode: "Cari mengikut nama, SKU atau imbas kod bar",
        Browse: "Cari",
        Stockhandling: "Pengendalian stok masuk",
        Stockinreturnedproduct: "Stok masuk produk pemulangan",
        Ontoinventory: "Hidup — item pemulangan akan ditambah semula ke inventori",
        Offreturnedonly: "Mati — item akan direkodkan sebagai dipulangkan sahaja",
        Usedrestock: "Digunakan untuk mengira pelarasan keuntungan semasa penambahan stok semula",
        Willaddedbackconfirmation: "Akan ditambah semula ke inventori selepas pengesahan",
        Returnreason: "Sebab pemulangan",
        Optional: "Pilihan",
        SelectReason: "Pilih Sebab",
        Additionalnotes: "Nota tambahan",
        Describeofcustomerexplanation: "Terangkan keadaan item yang dipulangkan, sebarang kerosakan yang kelihatan, penjelasan pelanggan...",
        Requiredmustfilledcontinue: "Medan yang diperlukan mesti diisi untuk meneruskan",
        Reviewdetailsbeforeconfirming: "Semak butiran sebelum mengesahkan",
        Replacementproductwilldeductedinventoryconfirmation: "Produk penggantian akan ditolak daripada inventori anda selepas pengesahan.",
        Choosereplacementproduct: "Pilih produk penggantian",
        Willdeductedfrominventoryconfirm: "Akan ditolak daripada inventori selepas pengesahan",
        Thesewillattachedothereturnrecord: "Imej-imej ini akan dilampirkan pada rekod pemulangan",
        Replacementitem: "Item penggantian",
        Addanotherproduct: "Tambah produk lain",
        Replacementproductwillbe: "Produk penggantian akan",
        deducted: "ditolak",
        fromyourinventoryconfirmation: "daripada inventori anda selepas pengesahan.",
        productadjustedusingprice: "Produk yang dipulangkan akan ditambah ke stok semula dan keuntungan dilaraskan menggunakan harga jualan asal.",
        Willloggedreturnedonlynotrestocked: "Akan direkodkan sebagai dipulangkan sahaja — tidak ditambah ke stok semula",
        Returnonly: "Pemulangan sahaja",
        Imagesofreturnedproduct: "Imej produk pemulangan",
        Returnedproductwill: "Produk pemulangan",
        not: "tidak",
        berestockedloggedreturnedonly: "akan ditambah ke stok semula — direkodkan sebagai dipulangkan sahaja.",
        AddImage: "Tambah Imej",
        STOCKIN: "STOK MASUK",
        LOGONLY: "LOG SAHAJA",
        ContinuetoReview: "Teruskan ke Semakan →",
        Confirmreplacement: "Sahkan penggantian",
        Confirmreturn: "Sahkan pemulangan",
        Filldetailsbelowproceed: "Isi butiran di bawah untuk meneruskan",
        Review: "Semakan",
        editdetails: "edit butiran",
        Configurereturndetails: "Konfigur butiran pemulangan",
        Configurereplacementdetails: "Konfigur butiran penggantian",
        SelectSource: "Pilih Sumber",
        Returning: "Memulangkan",
        Replacement: "Penggantian",
        WalkCustomer: "Pelanggan Walk-in",
        RETURNEDPRODUCT: "PRODUK DIPULANGKAN",
        REPLACEMENTPRODUCT: "PRODUK PENGGANTIAN",
        STOCKOUT: "STOK KELUAR",
        Netinventoryimpact: "Impak inventori bersih",
        Replacementitemcost: "Kos item penggantian",
        Returneditemrestockvalue: "Nilai stok semula item dipulangkan",
        PROFITINVENTORYSUMMARY: "RINGKASAN KEUNTUNGAN & INVENTORI",
        Inventoryaction: "Tindakan inventori",
        Valuededucted: "Nilai ditolak",
        Profitadjustment: "Pelarasan keuntungan",
        stockedout: " stok keluar",
        restocked: " stok semula",
        Noaction: "Tiada tindakan",
        Valuebeingreturned: "Nilai dipulangkan",
        Willberestocked: "Akan ditambah ke stok semula",
        Willbe: "Akan",
        logged: "direkodkan",
        ON: "HIDUP",
        OFF: "MATI",
        Linked: "Berkaitan",
        Pleaseselectreturnedproduct: "Sila pilih produk yang dipulangkan",
        Quantityrequired: "Kuantiti diperlukan",
        Buyingpricerequired: "Harga belian diperlukan",
        Pleaseaddleastreplacementproduct: "Sila tambah sekurang-kurangnya satu produk pengganti",
        Pleaseconfigurereturnedproductdetails: "Sila konfigurasi butiran produk yang dipulangkan",
        Pleaseselectcustomer: "Sila pilih pelanggan",
        Returndateisrequired: "Tarikh pemulangan diperlukan",
        Pleasefillallrequiredfields: "Sila isi semua medan yang diperlukan",
        Wildeductedfrominventory: "Akan ditolak daripada inventori",
        Currentprice: "Harga semasa",
        Defectivedamaged: "Cacat / rosak",
        Wrongitemreceived: "Item salah diterima",
        Customerchangedmind: "Pelanggan bertukar fikiran",
        Sizefitissue: "Masalah saiz / kesesuaian",
        Notasdescribed: "Tidak seperti yang diterangkan",
        Other: "Lain-lain",
        Originalsaleprice: "Harga jual asal (pelarasan keuntungan)",
        Addedbackinventory: "Ditambah semula ke inventori",
        Notaddedinventory: "Tidak ditambah ke inventori",
        replacedwith: "diganti dengan",
        deductedfrominventory: "didedahkan dari inventori",
        RETURNWITHSTOCKIN: "PULANG · DENGAN STOCK-IN",
        RETURNNOSTOCKIN: "PULANG · TIADA STOCK-IN",
        MULTIPLEREPLACEMENTS: "PENGGANTIAN BERBILANG",
        SINGLEREPLACEMENT: "PENGGANTIAN TUNGGAL",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "DIKEMBALIKKAN · STOCK IN",
        REPLACEMENTSTOCKOUT: "PENGGANTIAN · STOCK OUT",
        Returnonlylogsthisentry: "Pemulangan hanya mencatatkan entri ini —",
        nostockwillbeaddedorremoved: "tiada stok akan ditambah atau dikeluarkan",
        frominventory: "daripada inventori.",
        Whentousethis: "Bila hendak menggunakan ini:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Gunakan Pemulangan di akhir hari untuk merekodkan item yang dihantar untuk jualan yang kembali dalam keadaan rosak atau tidak dapat digunakan — item yang anda ingin jejaki tetapi tidak dapat dimasukkan semula ke dalam inventori.",
        Youcanviewallpastreturnentriesin: "Anda boleh melihat semua entri pemulangan yang lalu di",
        ReturnHistory: "Sejarah Pemulangan",
        underthe: "di bawah tab",
        Others: "Lain-lain",
        tab: ".",
        Negativestocktransactiondisabled: "Transaksi saham negatif dilumpuhkan."
    },
    NewRLocal: {
        Originalsaleprice: "Harga jual asal",
        Editinghistoryonlyinventorystaysunchanged: "Hanya menyunting sejarah — inventori kekal tidak berubah.",
        Changeshereupdatethisdetailsquantitiesaffected: "Perubahan di sini hanya mengemas kini butiran rekod ini (sebab, tarikh, nota). Kuantiti stok sebenar, lokasi bin, dan data produk anda tidak terjejas.",
        Needtofixinventorylevelsinstead: "Perlu membetulkan tahap inventori sebaliknya?",
        AdjustStock: "Laraskan Stok",
        Refund: "Bayaran Balik",
        ImportantNote: "Nota Penting",
        Pleasereviewbeforecontinuing: "Sila semak sebelum meneruskan",
        Onceshippedreceivedanyupdatesmadeorder: "Setelah pesanan dihantar atau diterima, sebarang kemas kini yang dibuat pada pesanan tidak akan dicerminkan dalam sejarah transaksi.",
        Thisundone: "Ini akan memadamkan pesanan secara kekal. Tindakan ini tidak boleh dibuat asal.",
        Inventorywilladjustedautomatically: "Inventori tidak akan dilaraskan secara automatik",
        Deletingthisreversevedshippedyouwillneed: "Memadamkan ini tidak membatalkan sebarang perubahan stok. Jika item telah diterima/dihantar, anda perlu",
        reflectthecorrectstocklevels: "untuk mencerminkan tahap stok yang betul.",
        manuallyadjustyourinventory: "laraskan inventori anda secara manual",
        Addremovestockforitemsthatwereshipped: "Tambah/buang stok untuk item yang telah dihantar",
        Addremovestockforitemsthatwerereceived: "Tambah/buang stok untuk item yang telah diterima",
        Updatecostrecordspaymentwaalreadymade: "Kemas kini rekod kos jika pembayaran telah dibuat",
        Reconcilerecordsandoutstandingpayments: "Suaikan rekod dan pembayaran tertunggak"
    },
    ReceivablesLocal: {
        Receivables: "Piutang",
        Manageandtrackcustomerduebalances: "Urus dan jejak baki tertunggak pelanggan",
        Viewcustomerduebalancereport: "Lihat laporan baki tertunggak pelanggan",
        Viewsupplierduebalancereport: "Lihat laporan baki tertunggak pembekal",
        DueBalance: "Baki Tertunggak",
        Unpaid: "Belum Dibayar",
        PartiallyPaid: "Sebahagian Dibayar",
        Paid: "Dibayar",
        HighestBalance: "Baki Tertinggi",
        LowestBalance: "Baki Terendah",
        Filldetailsrecordpayment: "Isi butiran untuk merekod bayaran",
        NewPaymentEntry: "Entri Bayaran Baharu",
        EditPaymentEntry: "Edit Entri Bayaran",
        Nosuppliersfound: "Tiada pembekal ditemui",
        Nocustomersfound: "Tiada pelanggan ditemui",
        LowtoHigh: 'Rendah ke Tinggi',
        HightoLow: 'Tinggi ke Rendah',
        AttachmentUploadedSc: "Lampiran berjaya dimuat naik",
        AttachmentUploadedF: "Gagal memuat naik lampiran",
        Pay: "Bayar",
        NoBillsFound: "Tiada Bil Ditemui",
        Thiscustomerhasunpaidbills: "Pelanggan ini tiada bil tertunggak.",
        TotalDue: "Jumlah Tertunggak",
        BillsFound: "Bil Ditemui",
        DeselectAll: "Nyahpilih Semua",
        SelectAll: "Pilih Semua",
        ShowDetails: "Tunjukkan Butiran"
    },
    AssetsNewLocal: {
        Assignedon: "Diserahkan pada",
        Total: "Jumlah",
        Assigned: "Diserahkan",
        Remaining: "Baki",
        Available: "Tersedia",
        NoSerialNumbers: "Tiada nombor siri",
        UpdateExistingAssetDetails: "Kemaskini butiran aset sedia ada",
        RegisterNewBusinessAsset: "Daftar aset perniagaan baru",
        BasicInformation: "Maklumat Asas",
        AssetDetails: "Butiran Aset",
        Quantity: "Kuantiti",
        SerialNumbers: "Nombor Siri",
        SerialNumberPlaceholder: "Nombor siri",
        AddSerialNumber: "Tambah Nombor Siri",
        SerialNumbersOptional: "Nombor siri adalah pilihan. Anda boleh menambah sehingga",
        AssetImages: "Gambar Aset",
        AdditionalNotes: "Nota Tambahan",
        AdditionalNotesPlaceholder: "Sebarang butiran tambahan atau sejarah penyelenggaraan...",
        Updating: "Mengemaskini...",
        Adding: "Menambah...",
        ITEquipmentPlaceholder: "cth. Peralatan IT",
        LoadingMoreActivities: "Memuatkan lebih banyak aktiviti...",
        AssignedAssets: "Aset yang Ditugaskan",
        Noassetsassignedstaffmember: "Tiada aset ditugaskan kepada kakitangan ini.",
        Assignassetstaff: "Tugaskan aset kepada kakitangan",
        Returnassetfromstaff: "Kembalikan aset ini daripada kakitangan",
        AssignmentDetails: "Butiran Penugasan",
        Serial: "Serial",
        ViewAssets: "Lihat Semua Aset",
        ViewByStaff: "Lihat Mengikut Kakitangan",
        AssignedHistory: "Sejarah Penugasan",
        Returned: "Dikembalikan",
        Returnedon: "Dikembalikan pada",
        ReturnedBy: "Dikembalikan oleh",
        AssignedTo: "Ditugaskan kepada",
        NoHistoryRecords: "Tiada rekod sejarah",
        Selectstaffmemberviewtheirassets: "Pilih kakitangan untuk melihat aset mereka.",
        Deleted: "DIPADAMKAN",
        searchPlaceholder: "Cari aset mengikut nama atau nombor siri..."
    },
    InventoryCountLocale: {
        InventoryCount: "Kiraan Inventori",
        Viewinventorycountreport: "Lihat laporan kiraan inventori",
        ItemsCount: "Bilangan Item",
        All: "Semua",
        InProgress: "Sedang Berjalan",
        Submitted: "Dihantar",
        awaitingreview: "Menunggu Semakan",
        EditInventoryCount: "Edit Kiraan Inventori",
        NewInventoryCount: "Kiraan Inventori Baharu",
        Modifyinventorycountsheetdetails: "Ubah suai butiran helaian kiraan",
        Startanewinventorycountsheet: "Mulakan helaian kiraan inventori baharu",
        GeneralInformation: "Maklumat Am",
        Title: "Tajuk",
        SaveChanges: "Simpan Perubahan",
        Selectproductsforthisinventorycountsheet: "Pilih produk untuk helaian ini",
        InventoryCountDetails: "Butiran Kiraan Inventori",
        Inventorycountsheetdetails: "Butiran helaian kiraan inventori",
        Viewingdetailsforcountsheet: "Melihat butiran helaian kiraan",
        Started: "Dimulakan",
        TaskSheets: "Helaian Tugas",
        Allitems: "Semua item",
        NotStarted: "Belum Dimulakan",
        Completed: "Selesai",
        Results: "Keputusan",
        ViewResults: "Lihat Keputusan",
        DeleteInventoryCount: "Padam Kiraan Inventori",
        Viewingtransactionandadjustments: "Melihat log transaksi dan pelarasan stok",
        Productsadjusted: "Produk yang dilaras",
        Assignee: "Ditugaskan kepada",
        Tasksheetdetails: "Butiran helaian tugas",
        Draft: "Draf",
        VariantQuantities: "Kuantiti Varian",
        AssignedProducts: "Produk yang Ditugaskan",
        ReturnAsset: "Kembalikan Aset",
        EditTasksheet: "Edit Lembar Tugas",
        NewTasksheet: "Lembar Tugas Baharu",
        Updatetasksheetdetails: "Kemas kini butiran lembar tugas",
        Starttasksheetforthisinventorycount: "Mulakan lembar tugas baharu untuk kiraan ini",
        TaskSheetInformation: "Maklumat Lembar Tugas",
        SheetTitle: "Tajuk Lembar",
        Entersheettitle: "Masukkan tajuk lembar",
        SubmissionResult: "Hasil Penyerahan",
        ReviewChanges: "Semak Perubahan",
        Viewingsubmissionresultsforthisinventorycount: "Melihat hasil penyerahan untuk kiraan ini",
        Reviewyourinventorycountbeforesubmitting: "Semak kiraan inventori anda sebelum menghantar"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Gagal memuat kiraan",
        NoInventoryCounts: "Tiada Kiraan Inventori",
        NoMatches: "Tiada Padanan",
        Therearenoinventorycountswiththestatus: "Tiada kiraan inventori dengan status",
        Noinventorycountsfoundyoursearchterm: "Tiada kiraan inventori ditemui yang sepadan dengan istilah carian anda.",
        Thereareinventorycountsrecordedyetforthisbusiness: "Tiada kiraan inventori direkodkan lagi untuk perniagaan ini."
    },
    StockinModalP: {
        StockInNow: "Masukkan Stok Sekarang",
        Settheopeningquantityforthisproductrightnow: "Tetapkan kuantiti pembukaan untuk produk ini sekarang.",
        Addinitialstock: "Tambah stok awal?",
        dothislater: "Saya akan buat kemudian",
        Productadded: "Produk berjaya ditambah!",
        isready: "sudah sedia.",
        SeeHowItWorks: "Lihat Cara Ia Berfungsi",
        NoSalesOrdersFound: "Tiada Pesanan Jualan Ditemui",
        NoPurchaseOrdersFound: "Tiada Pesanan Pembelian Ditemui",
        Startcreatingoutgoinginventoryrevenue: "Mulakan buat pesanan jualan untuk menjejak inventori keluar dan pendapatan.",
        Trackrestockssupplierplace: "Jejak restok inventori dan pesanan pembekal di satu tempat.",
        CreateSalesOrder: "Buat Pesanan Jualan",
        CreatePurchaseOrder: "Buat Pesanan Pembelian",
    }
    ,
    dialy_report: "Laporan Pergerakan Harian",
    Quotation: "Sebutharga",
    Quote: "Sebutharga",
    Assignee: "Ditugaskan kepada",
    dayStart: "Permulaan hari",

    ShowTotalAmount: "Jumlah Keseluruhan",


    tutorial: {
        watchTitle: 'Tonton tutorial langkah demi langkah',
        watchDesc: 'Ketahui SimplyStock di saluran YouTube kami',
        modalTitle: 'Teruskan dengan SimplyStock',
        modalDesc: 'Langgan untuk mendapatkan tutorial baharu sebaik sahaja mereka berhenti',
        feature1Title: 'Tinjauan ciri baharu',
        feature1Sub: 'Setiap kemas kini baharu diterangkan dengan video pendek — jadi anda tidak akan terlepas apa yang baharu',
        feature2Title: 'Video cara pantas',
        feature2Sub: 'Sediakan stok, invois, akses kakitangan dan banyak lagi dalam masa kurang dari 5 minit',
        feature3Title: 'Pemberitahuan segera',
        feature3Sub: 'Dapatkan pemberitahuan sebaik sahaja tutorial baharu disiarkan — pelajari mengikut kadar anda sendiri',
        feature4Title: '100% percuma, sentiasa',
        feature4Sub: 'Semua tutorial adalah percuma selama-lamanya — tiada log masuk atau langganan diperlukan',
        subscribeBtn: 'Langgan SimplyStock',
        maybeLater: 'Saya akan beritahu dia nanti.'
    }
    ,
    dailyCashReport: {
        "title": "Laporan Tunai Harian",
        "subtitle": "Siapa bayar apa, pada tarikh apa, dan apa yang masih tertunggak — dikumpulkan dari Butiran Jualan.",
        "totalSales": "Jumlah jualan",
        "cashReceived": "Jumlah Diterima",
        "outstanding": "Tertunggak",
        "collectionRate": "Kadar kutipan",
        "grandTotalAllDates": "JUMLAH KESELURUHAN (semua tarikh)",
        "totalLabel": "Jumlah",
        "loading": "Memuatkan...",
        "noData": "Tiada data dijumpai untuk julat tarikh yang dipilih.",
        "loadingMore": "Memuatkan lagi..."
    },
    dailyCashReportColumns: {
        "date": "Tarikh",
        "customer": "Pelanggan",
        "productsSold": "Produk Dijual",
        "products": "Produk",
        "salesAmount": "Jumlah Jualan",
        "sales": "Jualan",
        "received": "Jumlah Diterima",
        "receivedShort": "Diterima",
        "debited": "Didebitkan ke Lejar",
        "due": "Perlu Dibayar",
        "paymentModes": "Mod Pembayaran",
        "mode": "Mod"
    }
}

export default ms
